// 2024-10-07T09:50:20.537Z  (1728294620537)
export const locale = {
	lang: 'it',
	data: {
		'ACCOUNTING_VALUE': 'Valore contabile',
		'ACCOUNTING_VALUE.COMPUTE_IN_STATES': 'Calcolo solo in stati di lavoro selezionati',
		'ACCOUNTING_VALUE.VALUE_AGGREGATION': 'Aggregazione di valori',
		'ACCOUNTING_VALUE.VALUE_COMPUTATION': 'Calcolo del valore',
		'ACCOUNTING_VALUE.VALUE_SUMMATION': 'Somma di valori',
		'ACCOUNT_ACTIVATION': 'Attivazione del conto',
		'ACCOUNT_ACTIVATION.CODE': 'Codice di attivazione',
		'ACCOUNT_ACTIVATION.CODE.RESEND': 'Reinvio del codice di attivazione',
		'ACCOUNT_ACTIVATION.INTRO': 'Inserire il codice di attivazione ricevuto per e-mail',
		'ACID': 'Acido',
		'ACTIVATE': 'Attivare',
		'ACTIVATE.SELECTED': 'Attivare la selezione',
		'ACTIVE': 'Attivo',
		'ACTIVITIES.DAILY': 'Attività quotidiane',
		'ACTIVITIES.EXPORT': 'Attività di esportazione',
		'ACTIVITIES.NO': 'Nessuna attività',
		'ACTIVITIES.WEEKLY': 'Attività settimanali',
		'ACTIVITY': 'Attività',
		'ACTIVITY.EXPORT_DETAILS': 'Esportare l\'attività selezionata',
		'ACTIVITY.NO_FIELDS_WORKED': 'Nessun lavoro svolto su campi noti',
		'ADAPTER': 'Adattatore',
		'ADAPTER.ASSIGN': 'Assegnazione dell\'adattatore',
		'ADAPTER.ASSIGN.FAILURE': 'Si è verificato un errore nell\'accoppiamento dell\'adattatore',
		'ADAPTER.ASSIGN.SUCCESS': 'Adattatore assegnato con successo',
		'ADAPTER.ASSIGNED_MACHINE': 'Macchina assegnata',
		'ADAPTER.ASSIGNMENT': 'Assegnazione degli adattatori alle macchine',
		'ADAPTER.CHOSEN': 'Adattatore scelto',
		'ADAPTER.LOAD.FAILURE': 'Si è verificato un errore nel caricamento degli adattatori',
		'ADAPTER.NO': 'Nessun adattatore',
		'ADAPTER.NONE_AVAILABLE': 'Nessun adattatore disponibile',
		'ADAPTER.PAIR_INFO': 'Selezionare l\'adattatore corrispondente. Gli adattatori già assegnati verranno sovrascritti con la nuova macchina. La nuova configurazione verrà caricata automaticamente al successivo riavvio dell\'adattatore.',
		'ADAPTER.PREVIOUS': 'Adattatore precedente',
		'ADAPTERS.NO': 'Nessun adattatore',
		'ADBLUE.LEVEL': 'Livello di AdBlue',
		'ADD': 'Aggiungi',
		'ADDITIONAL_VALUE': 'Valore aggiunto',
		'ADDITIVE': 'Additivo',
		'ADDRESS': 'Indirizzo',
		'ALL': 'Tutti',
		'ALL_DEVICES': 'Dispositivi complessivi',
		'AMOUNT': 'Importo',
		'AMOUNT.INVALID': 'Importo non valido',
		'AMOUNTS': 'Importi',
		'APPLY': 'Applicare',
		'ARCHIVE': 'Archivio',
		'ARCHIVE.SELECTED': 'Archivio selezionato',
		'AREA': 'Area',
		'AREA.FIELD': 'Area',
		'AREA.LOCATION': 'Luoghi dell\'area',
		'AREA.PERFORMANCE': 'Area per h',
		'AREA.PROCESSED': 'Area processata',
		'AREA.TOTAL': 'Area totale',
		'AREA.WORKED': 'Area lavorata',
		'ASSIGN': 'Assegnazione',
		'AUTH.REMEMBER_ME': 'Ricordami',
		'BACK': 'Indietro',
		'BALES': 'Balle',
		'BASIC_DATA': 'Dati di base',
		'BEACON': 'Segnalatore',
		'BEACON.ASSIGN': 'Assegnazione del segnalatore',
		'BEACON.ASSIGN.SUCCESS': 'Segnalatore assegnato con successo',
		'BEACON.ASSIGNED_EMPLOYEE': 'Dipendente assegnato',
		'BEACON.ASSIGNED_IMPLEMENT': 'Implementazione assegnata',
		'BEACON.ASSIGN_TO_EMPLOYEE': 'Assegnare il segnalatore al dipendente',
		'BEACON.ASSIGN_TO_IMPLEMENT': 'Assegnare il beacon all\'implementazione',
		'BEACON.CHOSEN': 'Segnalatore prescelto',
		'BEACON.ERROR': 'Si è verificato un errore nell\'accoppiamento del segnalatore.',
		'BEACON.LOAD_ERROR': 'Si è verificato un errore nel caricamento del segnalatore',
		'BEACON.NONE_AVAILABLE': 'Nessun segnalatore disponibile',
		'BEACON.NO_BEACON': 'Nessun segnalatore',
		'BEACON.PAIR_INFO_EMPLOYEE': 'Selezionare il segnalatore corrispondente. I segnalatori già assegnati verranno sovrascritti con il nuovo dipendente.',
		'BEACON.PAIR_INFO_IMPLEMENT': 'Selezionare il beacon corrispondente. I beacon già assegnati verranno sovrascritti con il nuovo implementato.',
		'BEACON.PREVIOUS': 'Segnalatore precedente',
		'BEACONS': 'Segnalatori',
		'BUILD_YEAR': 'Anno di costruzione',
		'BUILD_YEAR.INVALID': 'Anno di costruzione non valido',
		'CAN.STATUS': 'Stato CAN',
		'CANCEL': 'Annullare',
		'CHANGE': 'Cambiamento',
		'CHANGE.NO': 'Nessuna variazione',
		'CHOOSE_ALL': 'Scegliere tutti',
		'CHOOSE_ROLE': 'Scegliere il ruolo',
		'CHRONOLOGICAL': 'Ordine cronologico',
		'CLICK_PROCESS': 'Selezionare un processo per maggiori dettagli',
		'CLOSE': 'Chiudere',
		'CO2.EMISSION': 'Emissioni di CO2',
		'CO2.PER': 'Quantità di CO2 per ettaro',
		'CO2.TOTAL': 'Quantità totale di CO2',
		'COLOR': 'Colore',
		'COMMENT': 'Commento',
		'CONDITION': 'Condizione',
		'CONFIRM': 'Confermare',
		'CONFIRM_PASSWORD': 'Conferma password',
		'CONNECT': 'Collegare',
		'CONTACT_PERSON': 'Persona di contatto',
		'CONTINUE': 'Continua',
		'COST': 'Costo',
		'COST.INVALID': 'Costo non valido',
		'COST.OVERALL': 'Costo complessivo',
		'COST.OVERALL.ARRIVAL': 'Costo complessivo di arrivo',
		'COST.OVERALL.DRIVER': 'Driver di costo complessivo',
		'COST.OVERALL.FIELD_TIME': 'Costo complessivo sul campo',
		'COST.OVERALL.IMPLEMENTS': 'Costo complessivo implementazioni',
		'COST.OVERALL.MACHINES': 'Costo complessivo macchine',
		'COST.OVERALL.PREPARATION': 'Preparazione dei costi complessivi',
		'COST.TOTAL': 'Costo totale',
		'COSTS': 'Costi',
		'COST_RATE': 'Tasso di costo',
		'COUNTRY': 'Paese',
		'COVERAGE': 'Coverage',
		'COVERAGE.MAP': 'Mappa di copertura',
		'COVERAGE.MAP.SETTINGS': 'Impostazioni della mappa di copertura',
		'COVERAGE.MAP.ZONES': 'Zone',
		'CREATED': 'Creato',
		'CREATE_USER': 'Creare un utente',
		'CROP.TYPE': 'Tipo di coltura',
		'CROP.NO_CROP': 'Nessuna coltura',
		'CURRENCY': 'Valuta',
		'CUSTOMER': 'Cliente',
		'CUSTOMER.ADD': 'Aggiungi un nuovo cliente',
		'CUSTOMER.ADD.SUCCESS': 'Cliente aggiunto con successo',
		'CUSTOMER.ASSIGN': 'Assegnazione del cliente',
		'CUSTOMER.DELETE.QUESTION': 'Volete davvero eliminare il cliente?',
		'CUSTOMER.DELETE.SUCCESS': 'Il cliente è stato cancellato',
		'CUSTOMER.DETAILS': 'Dettagli del cliente',
		'CUSTOMER.EDIT': 'Modifica il cliente',
		'CUSTOMER.EDIT.SUCCESS': 'Cliente modificato con successo',
		'CUSTOMER.NAME': 'Nome del cliente',
		'CUSTOMER.NO': 'Nessun cliente',
		'CUSTOMER.NOT_SELECTED': 'Nessun cliente selezionato',
    'CUSTOMER.NO.ASSIGNEE': 'Nessun cliente assegnato',
		'CUSTOMER.SELECT': 'Selezionare il cliente',
		'CUSTOMERS': 'Clienti',
		'CUSTOMERS.ALL': 'Tutti i clienti',
		'CUSTOMERS.DELETE.FAILURE': 'Alcuni clienti non potevano essere cancellati.',
		'CUSTOMERS.DELETE.QUESTION': 'Si desidera eliminare i clienti selezionati?',
		'CUSTOMERS.DELETE.SUCCESS': 'Clienti cancellati con successo',
		'CUSTOMERS.MANAGEMENT': 'Gestione dei clienti',
		'CUSTOMERS.NO': 'Nessun cliente',
		'CUSTOMERS.SELECTED': 'Clienti selezionati',
		'CUSTOM_LABELING': 'Etichettatura personalizzata',
		'CUSTOM_LABELING.ADD_WORKSTATE': 'Aggiungere un nuovo stato di lavoro',
		'CUSTOM_LABELING.DEFINE_FOR_IMPLEMENT': 'Definire un\'etichettatura personalizzata per l\'implementazione selezionata.',
		'CUSTOM_LABELING.DEFINE_INDIVIDUAL_CONDITION': 'Definire condizioni individuali per l\'etichetta.',
		'CUSTOM_LABELING.EDIT.SUCCESS': 'Modifica dell\'etichettatura personalizzata riuscita',
		'CUSTOM_LABELING.INDIVIDUAL_CONDITION': 'Condizione individuale',
		'CUSTOM_LABELING.ISOBUS_OVERRIDE': 'Consente l\'override con le condizioni ISOBUS',
		'CUSTOM_LABELING.NO_LABELS_AVAILABLE': 'Nessuna etichetta disponibile',
		'DASHBOARD.GPS_DATA.NO': 'Nessun dato GPS',
		'DASHBOARD.MACHINE_POSITIONS.LOAD.FAILURE': 'Si è verificato un errore nel caricamento delle posizioni della macchina',
		'DATA': 'Dati',
		'DATA.ARCHIVED.WARNING': 'I dati sottostanti sono parzial o completamente archiviati',
		'DATA.EXPORT': 'Esportazione dei dati',
		'DATA.INPUT': 'Data input',
		'DATA.UPDATING.WARNING': 'I dati di base sono in fase di aggiornamento',
		'DATA_PREPARATION': 'Preparazione dei dati',
		'DATE': 'Data',
		'DATE.APRIL': 'Aprile',
		'DATE.AUGUST': 'Agosto',
		'DATE.DECEMBER': 'Dicembre',
		'DATE.FEBRUARY': 'Febbraio',
		'DATE.FRIDAY': 'Venerdì',
		'DATE.FROM': 'Da',
		'DATE.JANUARY': 'Gennaio',
		'DATE.JULY': 'Luglio',
		'DATE.JUNE': 'Giugno',
		'DATE.MARCH': 'Marzo',
		'DATE.MAY': 'Maggio',
		'DATE.MONDAY': 'Lunedì',
		'DATE.NOVEMBER': 'Novembre',
		'DATE.OCTOBER': 'Ottobre',
		'DATE.PERIOD': 'Periodo',
		'DATE.RANGE': 'Intervallo di data',
		'DATE.SATURDAY': 'Sabato',
		'DATE.SEPTEMBER': 'Settembre',
		'DATE.SUNDAY': 'Domenica',
		'DATE.THURSDAY': 'Giovedì',
		'DATE.TUESDAY': 'Martedì',
		'DATE.UNTIL': 'Fino a',
		'DATE.WEDNESDAY': 'Mercoledì',
		'DAY.CURRENT': 'Giorno corrente',
		'DAY.NEXT': 'Il giorno dopo',
		'DAY.PREVIOUS': 'Giorno precedente',
		'DAY.SELECTED': 'Giorno selezionato',
		'DAYS': 'Giorni',
		'DAY_ACTIVITIES': 'Attività quotidiane',
		'DEACTIVATE': 'Disattivare',
		'DEACTIVATE.SELECTED': 'Disattivare selezionato',
		'DEADLINE': 'Scadenza',
		'DEADLINE.ADD': 'Aggiungi una scadenza',
		'DEADLINE.ADD.SUCCESS': 'Scadenza aggiunta con successo',
		'DEADLINE.DELETE.SUCCESS': 'Scadenza cancellata con successo',
		'DEADLINE.DONE': 'Finitura',
		'DEADLINE.DUE': 'Scadenza prevista',
		'DEADLINE.DUE_IN_AT': 'Scadenza in/al',
		'DEADLINE.EDIT': 'Modifica della scadenza',
		'DEADLINE.EDIT.SUCCESS': 'La scadenza è stata modificata',
		'DEADLINE.IS_CLOSE': 'La scadenza è imminente',
		'DEADLINE.IS_OVERDUE': 'Questa scadenza è in ritardo',
		'DEADLINE.OPEN': 'Aperto',
		'DEADLINE.PROCESS.SUCCESS': 'Scadenza elaborata con successo',
		'DEADLINE.PROCESSED': 'Elaborato',
		'DEADLINE.PROCESSED.SUCCESS': 'Scadenza elaborata con successo',
		'DEADLINE.WARN': 'Scadenza imminente',
		'DEADLINES': 'Scadenze',
		'DEADLINES.NO': 'Nessuna scadenza',
		'DEFINE_ROLE': 'Definire il ruolo',
		'DELETE': 'Cancellare',
		'DELETE.SELECTED': 'Cancellare la voce selezionata',
		'DELETED': 'Eliminato',
		'DESCRIPTION': 'Descrizione',
		'DIAGRAM': 'Diagramma',
		'DISPLAY': 'Display',
		'DISPLAY_TRACK': 'Traccia del display',
		'DISTANCE': 'Distanza',
		'DISTANCE.TOTAL': 'Distanza totale',
		'DISTANCE.WORKED': 'Distanza percorsa',
		'DOWNLOAD': 'Scaricare',
		'DRIVER': 'Conducente',
		'DRIVER.EDIT': 'Modifica del conducente',
		'DRIVER.FIXED': 'Correggere il conduttore',
		'DRIVER.NO': 'Nessun conducente',
		'DRIVER.REMOVE': 'Rimuovere il conducente',
		'DRIVERS': 'Conduttori',
		'DRIVERS.ALL': 'Tutti i conducenti',
		'DRIVER_SCAN_DISABLED': 'Scansione del segnalatore del conducente non attiva',
		'DURATION': 'Durata',
		'DURATION.WORKED': 'Durata del lavoro',
		'EDIT': 'Modifica',
		'EDIT.SELECTED': 'Modificare il selezionato',
		'EDIT_USER': 'Modifica utente',
		'EMAIL': 'Contatto e-mail',
		'EMAIL.ACTIVATE': 'Attivare l\'e-mail',
		'EMAIL.ACTIVATE.CODE': 'Codice di attivazione',
		'EMAIL.ACTIVATE.EXPLANATION': 'Se avete cambiato il vostro indirizzo e-mail, vi invieremo un codice di attivazione al vostro nuovo indirizzo.',
		'EMAIL.CHANGE': 'Modifica dell\'e-mail',
		'EMAIL.CHANGE.SUCCESS': 'L\'e-mail è stata modificata con successo',
		'EMAIL.CONFIRM': 'Confermare l\'e-mail',
		'EMAIL.CURRENT': 'Email corrente',
		'EMAIL.INVALID': 'Email non valida',
		'EMAIL.NEW': 'Nuova e-mail',
		'EMAIL.NO_MATCH': 'Le e-mail non corrispondono',
		'EMPLOYEE': 'Dipendente',
		'EMPLOYEE.ACTIVATE.QUESTION': 'Volete davvero attivare il dipendente?',
		'EMPLOYEE.ADD': 'Aggiungere un dipendente',
		'EMPLOYEE.ADD.SUCCESS': 'Dipendente aggiunto con successo',
		'EMPLOYEE.CREATE': 'Creare un dipendente',
		'EMPLOYEE.CREATE.SUCCESS': 'Dipendente creato con successo',
		'EMPLOYEE.DEACTIVATE.QUESTION': 'Si vuole davvero disattivare il dipendente?',
		'EMPLOYEE.DELETE.QUESTION': 'Volete davvero rimuovere il dipendente?',
		'EMPLOYEE.EDIT': 'Modifica dipendente',
		'EMPLOYEE.EDIT.SUCCESS': 'Dipendente modificato con successo',
		'EMPLOYEE.ROLE': 'Ruolo del dipendente',
		'EMPLOYEE.ROLE_OF': 'Ruolo del dipendente',
		'EMPLOYEES': 'I dipendenti',
		'EMPLOYEES.ACTIVATE.QUESTION': 'Volete davvero attivare i dipendenti?',
		'EMPLOYEES.ACTIVATE.SUCCESS': 'Dipendenti attivati con successo',
		'EMPLOYEES.ALL': 'Tutti i dipendenti',
		'EMPLOYEES.DEACTIVATE.FAILURE': 'Alcuni dipendenti non potevano essere disattivati.',
		'EMPLOYEES.DEACTIVATE.QUESTION': 'Si desidera davvero disattivare i dipendenti selezionati?',
		'EMPLOYEES.DEACTIVATE.SUCCESS': 'I dipendenti sono stati disattivati',
		'EMPLOYEES.DELETE.FAILURE': 'Non è stato possibile cancellare alcuni dipendenti.',
		'EMPLOYEES.DELETE.QUESTION': 'Si desidera davvero eliminare i dipendenti selezionati',
		'EMPLOYEES.DELETE.SUCCESS': 'Dipendenti cancellati',
		'EMPLOYEES.MANAGEMENT': 'Gestione dei dipendenti',
		'EMPLOYEES.NO': 'Nessun dipendente',
		'EMPLOYEES.NOT_SELECTED': 'Nessun dipendente selezionato',
		'EMPLOYEES.SELECTED': 'Dipendenti selezionati',
		'EMPLOYER.NO': 'Nessun datore di lavoro',
		'EMPLOYER.NOT_SELECTED': 'Nessun datore di lavoro selezionato',
		'EMPLOYES.NO': 'Nessun dipendente',
		'END_DRAW_MODE': 'Modalità di disegno annullata',
		'ENTERPRISE': 'Impresa',
		'ENTERPRISE.ADD': 'Aggiungi impresa',
		'ENTERPRISE.ADD.SUCCESS': 'Aggiunto con successo all\'impresa',
		'ENTERPRISE.ADD.EMPLOYER_REQUIRED': 'È necessario aggiungere un datore di lavoro',
		'ENTERPRISE.ADDED.SUCCESS': 'Azienda aggiunta con successo',
		'ENTERPRISE.ENTER_ACCESS_TOKEN': 'Inserire il codice di accesso dell\'impresa.',
		'ENTERPRISE.NAME': 'Nome dell\'impresa',
		'ENTERPRISE.NOT_SELECTED': 'Nessuna impresa selezionata',
		'ENTERPRISE.OF': 'Impresa di:',
		'ENTERPRISE.SETTINGS': 'Impostazioni aziendali',
		'ENTERPRISE.SETTINGS.CONFIGURATION_UPDATE.SUCCESS': 'La configurazione aziendale è stata aggiornata con successo',
		'ENTERPRISE.SETTINGS.MACHINES_SYNC.SUCCESS': 'Macchine sincronizzate con successo',
		'ENTERPRISE_LICENSE.EMPLOYEES': 'Licenze per i dipendenti',
		'ENTERPRISE_LICENSE.LICENSE': 'Licenza',
		'ENTERPRISE_LICENSE.MACHINE': 'Licenza della macchina',
		'ENTERPRISE_LICENSE.MACHINES': 'Licenze per macchine',
		'ENTERPRISE_MIN': 'Il nome dell\'impresa deve contenere almeno 3 caratteri',
		'ENTERPRISE_NAME_REQUIRED': 'Nome dell\'impresa richiesto',
		'ENTERPRISE_SELECTION.ADD_ENTERPRISE': 'Aggiungi impresa',
		'ENTERPRISE_SELECTION.LICENSE_EXPIRED': 'Licenza scaduta',
		'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT': 'Richiesta di un account di prova',
		'ENTERPRISE_STATISTICS': 'Statistiche aziendali',
		'ENTERPRISE_STATISTICS.COST_DIAGRAMM': 'Diagramma dei costi',
		'ENTERPRISE_STATISTICS.PROCESS_DIVISION': 'Divisione di processo',
		'ENUM.ACCOUNTING_COMP_MODE.A': 'Tutti',
		'ENUM.ACCOUNTING_COMP_MODE.WT': 'Lavoro / Trasporto',
		'ENUM.ACCOUNTING_MODE.AVG': 'Media',
		'ENUM.ACCOUNTING_MODE.MAX': 'Massimo',
		'ENUM.ACCOUNTING_MODE.MED': 'Mediana',
		'ENUM.ACCOUNTING_MODE.MIN': 'Minimo',
		'ENUM.ACCOUNTING_MODE.SUM': 'Somma',
		'ENUM.ACCOUNTING_VALUE_MODE.ABSDIF': 'Differenza assoluta',
		'ENUM.ACCOUNTING_VALUE_MODE.DIR': 'Diretto',
		'ENUM.ACCOUNTING_VALUE_MODE.NEGDIF': 'Differenza negativa',
		'ENUM.ACCOUNTING_VALUE_MODE.POSDIF': 'Differenza positiva',
		'ENUM.ACCOUNTING_VALUE_MODE.TIMACT': 'Tempo attivo',
		'ENUM.BEACONTYPE.BDrv': 'Lampeggiante per autisti',
		'ENUM.BEACONTYPE.BImpl': 'Implementare il beacon',
		'ENUM.CAN_IDENTIFIER.A1': ' IO-Box: Analogico 1 ',
		'ENUM.CAN_IDENTIFIER.A2': ' IO-Box: Analogico 2 ',
		'ENUM.CAN_IDENTIFIER.A3': 'IO-Box: Analogico 3',
		'ENUM.CAN_IDENTIFIER.A4': 'IO-Box: Analogico 4',
		'ENUM.CAN_IDENTIFIER.AUX0_Ext_Fl': 'Flusso esterno AUX0',
		'ENUM.CAN_IDENTIFIER.AUX0_Ret_Fl': 'Flusso di rientro AUX0',
		'ENUM.CAN_IDENTIFIER.AUX1_Ext_Fl': 'Flusso esterno AUX1',
		'ENUM.CAN_IDENTIFIER.AUX1_Ret_Fl': 'Flusso di rientro AUX1',
		'ENUM.CAN_IDENTIFIER.AUX2_Ext_Fl': 'Flusso esterno AUX2',
		'ENUM.CAN_IDENTIFIER.AUX2_Ret_Fl': 'Flusso di rientro AUX2',
		'ENUM.CAN_IDENTIFIER.AUX3_Ext_Fl': 'Flusso esterno AUX3',
		'ENUM.CAN_IDENTIFIER.AUX3_Ret_Fl': 'Flusso di rientro AUX3',
		'ENUM.CAN_IDENTIFIER.AUX4_Ext_Fl': 'Flusso esterno AUX4',
		'ENUM.CAN_IDENTIFIER.AUX4_Ret_Fl': 'Flusso di rientro AUX4',
		'ENUM.CAN_IDENTIFIER.Ag1avg': 'IO-Box: Angolo 1 medio',
		'ENUM.CAN_IDENTIFIER.Ag1max': 'IO-Box: Angolo 1 max',
		'ENUM.CAN_IDENTIFIER.Ag1min': 'IO-Box: Angolo 1 min',
		'ENUM.CAN_IDENTIFIER.Ag2avg': 'IO-Box: Angolo 2 medio',
		'ENUM.CAN_IDENTIFIER.Ag2max': 'IO-Box: Angolo 2 max',
		'ENUM.CAN_IDENTIFIER.Ag2min': 'IO-Box: Angolo 2 min',
		'ENUM.CAN_IDENTIFIER.Ag3avg': 'IO-Box: Angolo 3 medio',
		'ENUM.CAN_IDENTIFIER.Ag3max': 'IO-Box: Angolo 3 max',
		'ENUM.CAN_IDENTIFIER.Ag3min': 'IO-Box: Angolo 3 min',
		'ENUM.CAN_IDENTIFIER.ApplAci': 'SyreN: Acido applicato',
		'ENUM.CAN_IDENTIFIER.ApplAdd': 'SyreN: additivi applicati',
		'ENUM.CAN_IDENTIFIER.ApplSlu': 'SyreN: liquame applicato',
		'ENUM.CAN_IDENTIFIER.AxleWeight_1': 'Peso dell\'asse 1',
		'ENUM.CAN_IDENTIFIER.AxleWeight_2': 'Peso dell\'asse 2',
		'ENUM.CAN_IDENTIFIER.C1': 'IO-Box: Contatore 1',
		'ENUM.CAN_IDENTIFIER.C2': 'IO-Box: Contatore 2',
		'ENUM.CAN_IDENTIFIER.Chop_Act': 'Chopper ',
		'ENUM.CAN_IDENTIFIER.Circ_1_Stat': ' Circ_1_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_2A_Stat': ' Circ_2A_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_2B_Stat': 'Circ_2B_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_3_Stat': 'Circ_3_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_4_Stat': ' Circ_4_Stat ',
		'ENUM.CAN_IDENTIFIER.ClutSlip': 'Slittamento della frizione',
		'ENUM.CAN_IDENTIFIER.Cutter_Guide': 'Guida della fresa',
		'ENUM.CAN_IDENTIFIER.Cutter_GuideP': 'Guida della fresa (P)',
		'ENUM.CAN_IDENTIFIER.Cutter_Pos': 'Posizione della fresa',
		'ENUM.CAN_IDENTIFIER.Cutter_State': 'Taglierina',
		'ENUM.CAN_IDENTIFIER.D1': 'IO-Box: Digitale 1',
		'ENUM.CAN_IDENTIFIER.D2': 'IO-Box: Digitale 2',
		'ENUM.CAN_IDENTIFIER.D3': 'IO-Box: Digitale 3',
		'ENUM.CAN_IDENTIFIER.D4': 'IO-Box: Digitale 4',
		'ENUM.CAN_IDENTIFIER.Driv_Lever': 'Leva di azionamento',
		'ENUM.CAN_IDENTIFIER.ENG_ABLev': 'Livello di AdBlue',
		'ENUM.CAN_IDENTIFIER.ENG_FueLev': 'Livello del combustibile',
		'ENUM.CAN_IDENTIFIER.ENG_FueRat': 'Tasso di combustible',
		'ENUM.CAN_IDENTIFIER.ENG_Spe': ' RPM ',
		'ENUM.CAN_IDENTIFIER.ENG_Tor': 'Torque ',
		'ENUM.CAN_IDENTIFIER.FHitch_Pos': 'Posizione del gancio anteriore',
		'ENUM.CAN_IDENTIFIER.FPTO_Eng': 'PDF anteriore attiva',
		'ENUM.CAN_IDENTIFIER.FPTO_Spe': 'Velocità della PDF anteriore',
		'ENUM.CAN_IDENTIFIER.Field_Switch': 'Campo_Scambio',
		'ENUM.CAN_IDENTIFIER.Field_Switch2': 'Campo_Scambio2',
		'ENUM.CAN_IDENTIFIER.Front_Draft': 'Bozza del fronte',
		'ENUM.CAN_IDENTIFIER.Front_NForce': 'Bozza (nominale) anteriore',
		'ENUM.CAN_IDENTIFIER.GB_Dir': 'Direzione (a terra)',
		'ENUM.CAN_IDENTIFIER.GB_Speed': 'Velocità a terra',
		'ENUM.CAN_IDENTIFIER.GPS_Speed': 'Velocità GPS',
		'ENUM.CAN_IDENTIFIER.Gear_Sel': 'Ingranaggio selezionato',
		'ENUM.CAN_IDENTIFIER.GrainCnv_Pos': 'Posizione del trasportatore di cereali',
		'ENUM.CAN_IDENTIFIER.GrainTnk_Lev': 'Livello del serbatoio del grano',
		'ENUM.CAN_IDENTIFIER.HySt_Dir': ' HySt_Dir ',
		'ENUM.CAN_IDENTIFIER.HySt_Mod': 'HySt_Mod ',
		'ENUM.CAN_IDENTIFIER.Impl_Work': 'Implementare lo stato di lavoro',
		'ENUM.CAN_IDENTIFIER.JbSta': 'SyreN: lavoro attivo',
		'ENUM.CAN_IDENTIFIER.Mot_L_Spe': 'Velocità del motore (sinistra)',
		'ENUM.CAN_IDENTIFIER.Mot_L_Tor': 'Coppia motore (sinistra)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Spe': 'Velocità del motore (destra)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Tor': 'Coppia del motore (destra)',
		'ENUM.CAN_IDENTIFIER.NO_XTR': 'Nessun valore',
		'ENUM.CAN_IDENTIFIER.NUE_abs': 'SyreN: NUE assoluto',
		'ENUM.CAN_IDENTIFIER.NUE_rel': 'SireN: NUE relativo',
		'ENUM.CAN_IDENTIFIER.PHSlu': 'SireN: pH del liquame',
		'ENUM.CAN_IDENTIFIER.PTO_Switch': 'Interruttore PDF',
		'ENUM.CAN_IDENTIFIER.PTO_Switch1': 'Interruttore PDF1',
		'ENUM.CAN_IDENTIFIER.PTO_Switch2': 'Interruttore PDF2',
		'ENUM.CAN_IDENTIFIER.PTO_Switch3': 'Interruttore PDF3',
		'ENUM.CAN_IDENTIFIER.PrxSen': 'IO-Box: Sensore di prossimità',
		'ENUM.CAN_IDENTIFIER.RHitch_Pos': 'Posizione del gancio posteriore',
		'ENUM.CAN_IDENTIFIER.RPTO_Eng': 'PDF posteriore attiva',
		'ENUM.CAN_IDENTIFIER.RPTO_Spe': 'Velocità della PDF posteriore',
		'ENUM.CAN_IDENTIFIER.Rear_Draft': 'Bozza posteriore',
		'ENUM.CAN_IDENTIFIER.Rear_NForce': 'Pescaggio (nominale) posteriore',
		'ENUM.CAN_IDENTIFIER.Roll': 'IO-Box: Rollrate',
		'ENUM.CAN_IDENTIFIER.Sli': 'Scivolamento',
		'ENUM.CAN_IDENTIFIER.Spe': 'Velocità',
		'ENUM.CAN_IDENTIFIER.StrawChop_Pos': 'Posizione di straccivendolo',
		'ENUM.CAN_IDENTIFIER.Thresh_Drum': 'Tamburo per la trebbiatura',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A1': 'Pressione dei pneumatici sinistri A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A2': 'Pressione dei pneumatici sinistri A2',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A1': 'pressione del pneumatici destri A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A2': 'pressione del pneumatici destri A2',
		'ENUM.CAN_IDENTIFIER.UnlAuger_Act': ' UnlAuger_Act ',
		'ENUM.CAN_IDENTIFIER.WB_Dir': 'Direzione (basata sulla ruota)',
		'ENUM.CAN_IDENTIFIER.WB_Speed': 'Velocità basata su ruote',
		'ENUM.CAN_IDENTIFIER.Xacc': 'IO-Box: Accelerazione X',
		'ENUM.CAN_IDENTIFIER.Yacc': 'IO-Box: Accelerazione Y',
		'ENUM.CAN_IDENTIFIER.Yaw': 'IO-Box: Imbardata',
		'ENUM.CAN_IDENTIFIER.Yield_Act': 'Rendimento effettivo',
		'ENUM.CAN_IDENTIFIER.Yield_Mois': 'Umidità della resa',
		'ENUM.CAN_IDENTIFIER.Zacc': 'IO-Box: Accelerazione Z',
		'ENUM.COSTPER.h': ' h ',
		'ENUM.COSTPER.ha': ' ha ',
		'ENUM.COSTPER.km': ' km ',
		'ENUM.COSTPER.l': 'l',
		'ENUM.CURRENCY.DOLLAR': ' $ ',
		'ENUM.CURRENCY.EURO': ' € ',
		'ENUM.CURRENCY.GBP': ' £ ',
		'ENUM.EMPLOYEEROLE.ADMIN': 'Amministratore',
		'ENUM.EMPLOYEEROLE.CONSULTANT': 'Consulente',
		'ENUM.EMPLOYEEROLE.DISPONENT': 'Dispacciatore',
		'ENUM.EMPLOYEEROLE.DRIVER': 'Autista',
		'ENUM.EVENTTYPE.COMMENT': 'Messaggio',
		'ENUM.EVENTTYPE.CT': 'Contatore',
		'ENUM.EVENTTYPE.CT_RS': 'Azzeramento del contatore',
		'ENUM.EVENTTYPE.CUSTOMER': 'Cliente',
		'ENUM.EVENTTYPE.EMPL_C_IMPL': 'Le coppie di dipendenti implementano',
		'ENUM.EVENTTYPE.EMPL_E_FIELD': 'Il dipendente entra nel campo',
		'ENUM.EVENTTYPE.EMPL_E_MACH': 'Il dipendente entra nel trattore',
		'ENUM.EVENTTYPE.EMPL_L_FIELD': 'Il dipendente lascia il campo',
		'ENUM.EVENTTYPE.EMPL_L_MACH': 'Il dipendente lascia il trattore',
		'ENUM.EVENTTYPE.EMPL_P_START': 'Il dipendente inizia la pausa',
		'ENUM.EVENTTYPE.EMPL_P_STOP': 'Il dipendente termina la pausa',
		'ENUM.EVENTTYPE.EMPL_UC_IMPL': 'Il dipendente disaccoppia l\'attrezzo',
		'ENUM.EVENTTYPE.EMPL_W_START': 'Il dipendente inizia a lavorare',
		'ENUM.EVENTTYPE.EMPL_W_STOP': 'Il dipendente termina il lavoro',
		'ENUM.EVENTTYPE.GTO70': 'Serbatoio del grano pieno',
		'ENUM.EVENTTYPE.JOBINFO': 'Info sul lavoro',
		'ENUM.EVENTTYPE.JOB_PAUSE': 'Pausa lavoro',
		'ENUM.EVENTTYPE.JOB_RESUME': 'Riprendere il lavoro',
		'ENUM.EVENTTYPE.JOB_START': 'Inizio del lavoro',
		'ENUM.EVENTTYPE.JOB_STOP': 'Arresto del lavoro',
		'ENUM.EVENTTYPE.L_IMPL': 'Implementazione caricata',
		'ENUM.EVENTTYPE.REFUELING': 'Rifornimento di carburante',
		'ENUM.EVENTTYPE.SYREN_CUSTOMER': 'Cliente SyreN',
		'ENUM.EVENTTYPE.SYREN_FIELD': 'Campo di sinizzazione',
		'ENUM.EVENTTYPE.SYREN_SLURRY_TYPE': 'Tipo di liquame SyreN',
		'ENUM.EVENTTYPE.T2_ON': 'Adapter online',
		'ENUM.EVENTTYPE.UL_IMPL': 'Implementazione scaricata',
		'ENUM.EVENTTYPE.WEATHER': 'Il tempo',
		'ENUM.EVENTTYPE.WEIGHING': 'Pesatura',
		'ENUM.EVENTTYPE.WEIGHING_TARA': 'Pesatura (tara)',
		'ENUM.ISO_TASKDATA_STATE.CRE': 'Creato',
		'ENUM.ISO_TASKDATA_STATE.ONM': 'Su macchina',
		'ENUM.ISO_TASKDATA_STATE.RDY': 'Pronto',
		'ENUM.JOBGENERATIONSTATE.ARC': 'Archiviato',
		'ENUM.JOBGENERATIONSTATE.DEL': 'Eliminazione',
		'ENUM.JOBGENERATIONSTATE.EDT': 'Editar ',
		'ENUM.JOBGENERATIONSTATE.GEN': 'Generazione',
		'ENUM.JOBGENERATIONSTATE.MER': 'Fusione',
		'ENUM.JOBGENERATIONSTATE.QUE': 'In coda',
		'ENUM.JOBGENERATIONSTATE.READY': ' OK ',
		'ENUM.JOBGENERATIONSTATE.REGEN': 'Rigenerante',
		'ENUM.JOBGENERATIONSTATE.SPLT': 'Dividere',
		'ENUM.JOBGENERATIONSTATE.UPD': 'Aggiornamento',
		'ENUM.LOCATIONTYPE.FARM': 'Fattoria',
		'ENUM.LOCATIONTYPE.FUEL': 'Stazione di rifornimento',
		'ENUM.LOCATIONTYPE.OTHERS': 'Altro',
		'ENUM.LOCATIONTYPE.STABLE': 'Stabile',
		'ENUM.LOCATIONTYPE.WEIGHING': 'Scala',
		'ENUM.MACHINETYPE.COMBINE': 'Mietitrebbia',
		'ENUM.MACHINETYPE.EXCAVATOR': 'Escavatore',
		'ENUM.MACHINETYPE.FORAGE_HARVESTER': 'Raccoglitore di foraggio',
		'ENUM.MACHINETYPE.MISC': 'Altro',
		'ENUM.MACHINETYPE.SELF_PROPELLED': 'Semovente',
		'ENUM.MACHINETYPE.SYREN': ' Syren ',
		'ENUM.MACHINETYPE.TELEHANDLER': 'Telescopio',
		'ENUM.MACHINETYPE.TRACTOR': 'Trattore',
		'ENUM.MACHINETYPE.TRUCK': 'Camion',
		'ENUM.MACHINETYPE.WHEELLOADER': 'Carrelli elevatori',
		'ENUM.MSGUNIT.-': ' - ',
		'ENUM.MSGUNIT.AXLES': 'Assali',
		'ENUM.MSGUNIT.CUBIC_M': ' m³ ',
		'ENUM.MSGUNIT.DOLLAR': ' $ ',
		'ENUM.MSGUNIT.EURO': ' € ',
		'ENUM.MSGUNIT.KG': ' kg ',
		'ENUM.MSGUNIT.LITER': ' l ',
		'ENUM.MSGUNIT.TONS': ' t ',
		'ENUM.MSGUNIT.h': ' h ',
		'ENUM.MSGUNIT.ha': ' ha ',
		'ENUM.MSGUNIT.km': ' km ',
		'ENUM.ONLY_ON_STATE.A': 'Sempre',
		'ENUM.ONLY_ON_STATE.F': 'Campo',
		'ENUM.ONLY_ON_STATE.L': 'Posizione',
		'ENUM.ONLY_ON_STATE.R': 'Strada',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_1200': 'AgLeader InCommand 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_800': 'AgLeader InCommand 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INTEGRA': 'AgLeader Integra',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_VERSA': 'AgLeader Versa',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD': 'Amazone Amapad',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD_2': 'Amazone Amapad 2',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_3': 'Amazone Amatron 3',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_4': 'Amazone Amatron 4',
		'ENUM.TRACTOR_TERMINAL_TYPE.AN_L10I': 'Andeo L10i',
		'ENUM.TRACTOR_TERMINAL_TYPE.A_XY': ' A_XY ',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_1200': 'Case AFS Pro 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_700': 'Case AFS Pro 700',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_1200': 'CCI 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_800': 'CCI 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_CEMIS_1200': 'Claas Cemis 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S10': 'Claas S10',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S7': 'Claas S7',
		'ENUM.TRACTOR_TERMINAL_TYPE.C_S2034': ' C_S2034 ',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_ONE': 'Fendt One',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_VARIOTERMINAL_10_4': 'Fendt Varioterminal 10.4',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_2630': 'John Deere 2630',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_GEN4': 'John Deere Gen4',
		'ENUM.TRACTOR_TERMINAL_TYPE.KV_TELLUS': 'Kverneland Tellus',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME': 'Müller Elektronik Basic',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_COMFORT': 'Müller Elektronik Comfort',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_1200': 'Müller Elektronik Touch 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_800': 'Müller Elektronik Touch 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.MF_DATATRONIC_5': 'MF Datatronic 5',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR12': 'Raven CR12',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR7': 'Raven CR7',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_VIPER4': 'Raven Viper4',
		'ENUM.TRACTOR_TERMINAL_TYPE.RH_SMART_COMMAND': 'Reichhardt Smart Command',
		'ENUM.TRACTOR_TERMINAL_TYPE.SDF_IMONITOR3': 'SDF iMonitor3',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X25': 'Topcon x25',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X30': 'Topcon x30',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X35': 'Topcon x35',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_XD': 'Topcon XD',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_1260': 'Trimble GFX 1260',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_750': 'Trimble GFX 750',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_TMX_2050': 'Trimble TMX 2050',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_1': 'Tipo 1 (scrive su chiavetta USB)',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_2': 'Tipo 2 (non scrive sulla chiavetta USB)',
		'ENUM.TRANSPORTUNIT.-': ' - ',
		'ENUM.TRANSPORTUNIT.AXLES': 'Assali',
		'ENUM.TRANSPORTUNIT.BALE': 'Balla',
		'ENUM.TRANSPORTUNIT.CUBIC_M': ' m³ ',
		'ENUM.TRANSPORTUNIT.KG': 'kg ',
		'ENUM.TRANSPORTUNIT.LITER': ' l ',
		'ENUM.TRANSPORTUNIT.TONS': ' t ',
		'ENUM.USERROLE.ADMIN': 'Amministratore',
		'ENUM.USERROLE.ENTERPRISE': 'Impresa',
		'ENUM.USERROLE.SALES_FORCE_TECH': 'Tecnologia Saleforce',
		'ENUM.USERROLE.TRAN': 'Traduzione',
		'ENUM.USERROLE.USER': 'Utente',
		'ENUM.USERROLE.USER_EMPL': 'Utente (Impresa)',
		'ENUM.USERSTATE.ACTIVE': 'Attivo',
		'ENUM.USERSTATE.DISABLED': 'Disabili',
		'ENUM.USERSTATE.NOT_VERIFIED': 'Non verificato',
		'ENUM.WORKSTATE.DRIVING': 'Guida',
		'ENUM.WORKSTATE.DRIVING_MISC': 'Guida in attesa',
		'ENUM.WORKSTATE.MISC_FIELD': 'Campo di attesa',
		'ENUM.WORKSTATE.MISC_FIELD_GTF': 'Serbatoio del grano pieno',
		'ENUM.WORKSTATE.MISC_ROAD': 'Strada di attesa',
		'ENUM.WORKSTATE.PAUSE': 'Pausa',
		'ENUM.WORKSTATE.PREPARATION': 'Preparazione',
		'ENUM.WORKSTATE.ROAD': 'Strada',
		'ENUM.WORKSTATE.THRESHING': 'Trebbiatura',
		'ENUM.WORKSTATE.THRESHING_U': 'Scarico durante la trebbiatura',
		'ENUM.WORKSTATE.THRESHING_W_SC': 'Trebbiatura con trinciapaglia',
		'ENUM.WORKSTATE.THRESHING_W_SC_U': 'Scarico durante la trebbiatura con trinciapaglia',
		'ENUM.WORKSTATE.TRANSPORT_LOADED': 'Caricato',
		'ENUM.WORKSTATE.TRANSPORT_LOADED_MISC': 'Attesa carica',
		'ENUM.WORKSTATE.TRANSPORT_LOADING': 'Caricamento',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED': 'Scarico',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED_MISC': 'Attesa scarica',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING': 'Scarico',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING_DRIV': 'Scarico durante la guida',
		'ENUM.WORKSTATE.TURNING': 'Giramenti',
		'ENUM.WORKSTATE.UNDEFINED': 'Non definito',
		'ENUM.WORKSTATE.WORKING': 'Lavoro',
		'ENUM.WORKSTATE.WORKING_MISC': 'In attesa di lavorare',
		'ERROR.NO_GPS_DATA': 'Nessun dato GPS per la macchina selezionata.',
		'ERROR_MESSAGE': 'Messaggio di errore',
		'EVENTS': 'Eventi',
		'EVENTS.FIELD': 'Eventi sul campo',
		'EVENTS.NO': 'Nessun evento',
		'EXA_ADAPTERS': 'Adattatore',
		'EXA_ADAPTERS.AR_ACTIVATE': 'Attivare l\'adattatore in Agrirouter',
		'EXA_ADAPTERS.AR_DEACTIVATE': 'Cancellare l\'adattatore in Agrirouter',
		'EXA_ADAPTERS.AR_LINK_SUCCESS': 'Adattatore attivato in Agrirouter',
		'EXA_ADAPTERS.AR_UNLINK_SUCCESS': 'Adattatore cancellato da Agrirouter',
		'EXCEPTION.1': 'Errore interno',
		'EXCEPTION.100': 'Enum non valido',
		'EXCEPTION.1000': 'Il nome utente è vuoto',
		'EXCEPTION.10000': 'Il nome del file è vuoto',
		'EXCEPTION.10001': 'I dati sono vuoti',
		'EXCEPTION.10002': 'Tipo di formato non valido',
		'EXCEPTION.10003': 'Tipo di richiesta dati non valida',
		'EXCEPTION.10004': 'Nessun dato grezzo',
		'EXCEPTION.1001': 'La lunghezza del nome utente è inferiore alla lunghezza minima',
		'EXCEPTION.1002': 'Il nome utente è già stato preso',
		'EXCEPTION.1003': 'Indirizzo e-mail non valido',
		'EXCEPTION.1004': 'L\'indirizzo e-mail è già occupato',
		'EXCEPTION.1005': 'La lunghezza della password è inferiore alla lunghezza minima',
		'EXCEPTION.1007': 'Codice di verifica non valido',
		'EXCEPTION.1008': 'Nome utente (o indirizzo e-mail) non valido',
		'EXCEPTION.101': 'Ruolo del dipendente non valido',
		'EXCEPTION.1011': 'L\'utente non esiste',
		'EXCEPTION.1012': 'L\'utente è stato cancellato',
		'EXCEPTION.1013': 'L\'utente è inattivo',
		'EXCEPTION.1014': 'L\'utente è bloccato',
		'EXCEPTION.1015': 'L\'utente non è attivato',
		'EXCEPTION.1016': 'L\'utente è un account aziendale',
		'EXCEPTION.102': 'Valuta non valida',
		'EXCEPTION.1020': 'L\'utente esiste già',
		'EXCEPTION.1021': 'Indirizzo e-mail già preso',
		'EXCEPTION.1022': 'L\'indirizzo e-mail non è cambiato',
		'EXCEPTION.1023': 'La password attuale non corrisponde',
		'EXCEPTION.1024': 'Il nome utente è già stato preso',
		'EXCEPTION.1025': 'L\'utente e il codice non corrispondono',
		'EXCEPTION.1026': 'Nome utente (o indirizzo e-mail) non valido',
		'EXCEPTION.1027': 'Utente già attivato',
		'EXCEPTION.1028': 'Vietato per gli account dei dipendenti creati per un\'azienda',
		'EXCEPTION.103': 'Unità di trasporto non valida',
		'EXCEPTION.104': 'Tipo di posizione non valida',
		'EXCEPTION.105': 'Unità di costo non valida',
		'EXCEPTION.106': 'Unità non valida',
		'EXCEPTION.107': 'Tipo di macchina non valida',
		'EXCEPTION.108': 'Stato del dipendente non valido',
		'EXCEPTION.11000': 'Tipo non valido',
		'EXCEPTION.12000': 'Tipo non valido',
		'EXCEPTION.12002': 'Il seriale è vuoto',
		'EXCEPTION.12003': 'Stato di lavoro non valido',
		'EXCEPTION.12004': 'Stato del lavoro non valido',
		'EXCEPTION.12006': 'Nessuna configurazione T2',
		'EXCEPTION.12007': 'Il MAC è vuoto',
		'EXCEPTION.12008': 'MAC non valido',
		'EXCEPTION.12009': 'L\'adattatore esiste già',
		'EXCEPTION.12010': 'Tipo di adattatore non valido',
		'EXCEPTION.15000': 'L\'ora di inizio è vuota o futura',
		'EXCEPTION.15001': 'Il tempo di arresto è vuoto o futuro',
		'EXCEPTION.15002': 'L\'ora di arresto è uguale o precedente all\'ora di inizio',
		'EXCEPTION.15003': 'Impossibile generare il pacchetto SILO - nessun dato grezzo',
		'EXCEPTION.15004': 'Dati grezzi troppo vecchi',
		'EXCEPTION.16000': 'Il nome è vuoto',
		'EXCEPTION.16001': 'Il cliente assegnato non esiste',
		'EXCEPTION.16002': 'L\'elenco dei marcatori è vuoto',
		'EXCEPTION.16003': 'L\'elenco dei marcatori deve contenere almeno tre marcatori',
		'EXCEPTION.16004': 'L\'area è vuota',
		'EXCEPTION.16005': 'Tipo di marcatore non valido',
		'EXCEPTION.16006': 'Il campo non è contenuto nel lavoro',
		'EXCEPTION.16007': 'La dimensione della griglia è superiore alla metà dell\'altezza e della larghezza del campo.',
		'EXCEPTION.16008': 'Nessun dato da interpolare',
		'EXCEPTION.16009': ' All data contain the same value ',
		'EXCEPTION.17000': 'Il nome è vuoto',
		'EXCEPTION.17001': 'Il contatto è vuoto',
		'EXCEPTION.17002': 'Il telefono è vuoto',
		'EXCEPTION.17003': 'L\'indirizzo e-mail è vuoto',
		'EXCEPTION.17004': 'Indirizzo e-mail non valido',
		'EXCEPTION.17005': 'L\'indirizzo è vuoto',
		'EXCEPTION.17006': 'Il codice postale è vuoto',
		'EXCEPTION.17007': 'La città è vuota',
		'EXCEPTION.17008': 'Colore non valido ((AA)RRGGBB)',
		'EXCEPTION.18000': 'Tipo non valido',
		'EXCEPTION.19001': 'Tipo non valido',
		'EXCEPTION.19002': 'Il MAC è vuoto',
		'EXCEPTION.19003': 'MAC non valido',
		'EXCEPTION.19004': 'La potenza è inferiore a zero',
		'EXCEPTION.19007': 'Il dipendente è vuoto',
		'EXCEPTION.19008': 'Beacon non è un faro da implementare',
		'EXCEPTION.19009': 'Beacon non è un driver beacon',
		'EXCEPTION.2': 'Voce duplicata',
		'EXCEPTION.200': 'Errore nell\'analisi del tipo di oggetto Json',
		'EXCEPTION.2000': 'Creazione del codice di verifica non riuscita',
		'EXCEPTION.20000': 'Quantità di dati grezzi troppo bassa',
		'EXCEPTION.20001': 'Creazione del file di archivio non riuscita',
		'EXCEPTION.20002': 'Caricamento del file di archivio non riuscito',
		'EXCEPTION.2001': 'Il codice di verifica non esiste',
		'EXCEPTION.2002': 'Codice di verifica non valido',
		'EXCEPTION.201': 'Errore nella scrittura del tipo di oggetto in Json',
		'EXCEPTION.21000': 'Il nome dell\'impresa è vuoto',
		'EXCEPTION.21001': 'Nome dell\'impresa già assegnato',
		'EXCEPTION.21002': 'La lunghezza del nome dell\'impresa è inferiore alla lunghezza minima',
		'EXCEPTION.21003': 'Indirizzo e-mail aziendale non valido',
		'EXCEPTION.21004': 'Il token di accesso esiste già',
		'EXCEPTION.21005': 'L\'impresa viene cancellata',
		'EXCEPTION.21006': 'L\'impresa è disattivata',
		'EXCEPTION.21007': 'L\'impresa è bloccata',
		'EXCEPTION.21008': 'Tipo di impresa non valido',
		'EXCEPTION.22000': 'Nessun lavoro da aggiungere',
		'EXCEPTION.22001': 'Nessun lavoro cambiato',
		'EXCEPTION.23000': 'Impresa non imbarcata',
		'EXCEPTION.23001': 'Enterprise già imbarcata',
		'EXCEPTION.23002': 'Adattatore non integrato',
		'EXCEPTION.23003': 'Adattatore già montato a bordo',
		'EXCEPTION.23004': 'Impossibile inserire l\'adattatore a bordo',
		'EXCEPTION.23005': 'Impossibile reimpostare l\'adattatore',
		'EXCEPTION.23006': 'Non è stato possibile scaricare l\'adattatore',
		'EXCEPTION.23007': 'Pubblicazione delle capacità della vCU non riuscita',
		'EXCEPTION.23008': 'Pubblicazione dei dati della vCU non riuscita',
		'EXCEPTION.23009': 'Pubblicazione fallita della descrizione del dispositivo vCU',
		'EXCEPTION.23010': 'Pubblicazione di funzionalità aziendali fallite',
		'EXCEPTION.23011': 'Errore del certificato Agrirouter! Avete rinnovato la connessione ad Agrirouter?',
		'EXCEPTION.24000': 'Il nome dell\'impresa è vuoto',
		'EXCEPTION.24001': 'Nome dell\'impresa già assegnato',
		'EXCEPTION.24002': 'La lunghezza del nome dell\'impresa è inferiore alla lunghezza minima',
		'EXCEPTION.24003': 'Indirizzo e-mail aziendale non valido',
		'EXCEPTION.24004': 'Il token di accesso esiste già',
		'EXCEPTION.24005': 'L\'impresa viene cancellata',
		'EXCEPTION.24006': 'L\'impresa è disattivata',
		'EXCEPTION.24007': 'L\'impresa è bloccata',
		'EXCEPTION.25000': 'Funzione non disponibile per il partner selezionato',
		'EXCEPTION.25001': 'Sincronizzazione dei campi fallita',
		'EXCEPTION.25002': 'Sincronizzazione delle macchine non riuscita',
		'EXCEPTION.25003': 'Sincronizzazione degli implementazioni fallita',
		'EXCEPTION.25004': 'Ottenere la macchina non è riuscito',
		'EXCEPTION.25005': 'Creazione della macchina non riuscita',
		'EXCEPTION.25006': 'Aggiornamento della macchina non riuscito',
		'EXCEPTION.25007': 'Eliminazione della macchina non riuscita',
		'EXCEPTION.25008': 'Implementazione fallita',
		'EXCEPTION.25009': 'Creazione di un\'implementazione non riuscita',
		'EXCEPTION.25010': 'Aggiornamento dell\'implementazione non riuscito',
		'EXCEPTION.25011': 'Eliminazione dell\'implementazione non riuscita',
		'EXCEPTION.26000': 'Creazione di un file PDF non riuscita',
		'EXCEPTION.26001': 'Il lavoro selezionato non è un lavoro abilitato a SyreN',
		'EXCEPTION.27000': 'La macchina non supporta i file TaskData',
		'EXCEPTION.27001': 'Creazione del file TaskData non riuscita',
		'EXCEPTION.27002': 'Caricamento del file TaskData non riuscito',
		'EXCEPTION.27003': 'La macchina non ha un adattatore assegnato',
		'EXCEPTION.27004': 'Il nome è vuoto',
		'EXCEPTION.27005': 'La data prevista è vuota',
		'EXCEPTION.27006': 'La data prevista non è futura',
		'EXCEPTION.27007': 'Lo stato è vuoto',
		'EXCEPTION.27008': 'Il file è vuoto',
		'EXCEPTION.27009': 'Il nome del file è vuoto',
		'EXCEPTION.27010': 'La data è vuota',
		'EXCEPTION.27011': 'La data non è nel futuro',
		'EXCEPTION.27012': 'La dimensione è inferiore a uno',
		'EXCEPTION.27013': 'Operazione TaskData non disponibile nello stato corrente',
		'EXCEPTION.27014': 'Nome del file già assegnato',
		'EXCEPTION.27015': 'Nessun compito aperto',
		'EXCEPTION.27016': 'È consentito un solo file TaskData non scaricato.',
		'EXCEPTION.28001': 'Tipo di file non supportato',
		'EXCEPTION.29000': 'Aggiornamento non consentito (già elaborato)',
		'EXCEPTION.29001': 'Nessuna macchina o implementazione fornita',
		'EXCEPTION.29002': 'È consentita solo una macchina o un implementazione',
		'EXCEPTION.29003': 'Il valore di base deve essere maggiore di zero',
		'EXCEPTION.29004': 'Il valore dell\'avviso deve essere maggiore di zero',
		'EXCEPTION.29005': 'Il valore dovuto deve essere maggiore di zero',
		'EXCEPTION.29006': 'L\'intervallo di scadenza deve essere maggiore dell\'intervallo di avviso',
		'EXCEPTION.3000': 'Informazioni di accesso non valide',
		'EXCEPTION.3001': 'Il conto è bloccato',
		'EXCEPTION.3002': 'Il conto non è attivato',
		'EXCEPTION.3003': 'Sessione scaduta - Effettuare nuovamente il login',
		'EXCEPTION.3004': 'Un altro utente ha effettuato l\'accesso con lo stesso conto',
		'EXCEPTION.31000': 'App non supportata',
		'EXCEPTION.4000': 'Il produttore è vuoto',
		'EXCEPTION.4001': 'Il modello è vuoto',
		'EXCEPTION.4002': 'L\'anno deve essere superiore al 1950 e non al futuro.',
		'EXCEPTION.4003': 'Il costo è inferiore o uguale a zero',
		'EXCEPTION.4004': 'Le ore di funzionamento sono inferiori a zero',
		'EXCEPTION.4005': 'Il chilometraggio è inferiore a zero',
		'EXCEPTION.4007': 'La larghezza di lavoro è inferiore a zero',
		'EXCEPTION.4008': 'Colore non valido ((AA)RRGGBB)',
		'EXCEPTION.4009': 'XtrCanValuesConfig non valido',
		'EXCEPTION.401': 'Non autorizzato',
		'EXCEPTION.4010': 'Troppi valori di configurazione',
		'EXCEPTION.4011': 'Configurazione dinamica non valida',
		'EXCEPTION.4012': 'Il tipo di macchina non è un trattore',
		'EXCEPTION.4013': 'Viene preso il numero massimo di licenze',
		'EXCEPTION.4014': 'La data è nel futuro',
		'EXCEPTION.4015': 'Override della velocità non valido',
		'EXCEPTION.403': 'Proibito',
		'EXCEPTION.450': 'Errore di comando',
		'EXCEPTION.451': 'Nessuna licenza richiesta',
		'EXCEPTION.452': 'Parametro del filtro non valido',
		'EXCEPTION.5000': 'Il produttore è vuoto',
		'EXCEPTION.5001': 'Il modello è vuoto',
		'EXCEPTION.5002': 'L\'anno deve essere superiore al 1950 e non al futuro.',
		'EXCEPTION.5003': 'Il tipo1 è vuoto',
		'EXCEPTION.5004': 'Il tipo 2 è vuoto',
		'EXCEPTION.5005': 'Il costo è inferiore o uguale a zero',
		'EXCEPTION.5006': 'La larghezza di lavoro è inferiore a zero',
		'EXCEPTION.5007': 'Il valore del trasporto è inferiore a zero',
		'EXCEPTION.5008': 'Unità di trasporto non valida',
		'EXCEPTION.5009': 'Tipo3 non valido',
		'EXCEPTION.5010': 'Combinazione di tipi non valida',
		'EXCEPTION.5011': 'Identificatore contabile non valido',
		'EXCEPTION.6000': 'Tipo non valido',
		'EXCEPTION.6001': 'Il raggio è vuoto o inferiore a zero',
		'EXCEPTION.6002': 'Il nome è vuoto',
		'EXCEPTION.6003': 'L\'elenco dei marcatori è vuoto',
		'EXCEPTION.6004': 'L\'elenco dei marcatori deve contenere almeno tre marcatori',
		'EXCEPTION.6005': 'Tipo di marcatore non valido',
		'EXCEPTION.6006': 'Tipo di pesatura non valido',
		'EXCEPTION.700': 'Nome VarNon valido',
		'EXCEPTION.7001': 'Il conto non esiste',
		'EXCEPTION.7002': 'Il conto è bloccato',
		'EXCEPTION.701': 'Formula non valida',
		'EXCEPTION.702': 'Nome ID CAN non valido',
		'EXCEPTION.703': 'Condizione non valida',
		'EXCEPTION.704': 'Nome variabile non valido',
		'EXCEPTION.705': 'Parametro di stato di lavoro non valido',
		'EXCEPTION.706': 'Stato di lavoro non valido per il tipo di implementazione',
		'EXCEPTION.707': 'Creazione del file non riuscita',
		'EXCEPTION.800': 'Nome ConfigValue non valido',
		'EXCEPTION.8000': 'Il datore di lavoro è vuoto',
		'EXCEPTION.8001': 'Il dipendente è vuoto',
		'EXCEPTION.8002': 'Dipendente non trovato per il datore di lavoro',
		'EXCEPTION.8003': 'Costo inferiore a zero',
    'EXCEPTION.8004': 'Numero massimo di licenze utente utilizzate',
		'EXCEPTION.8005': 'Non il vostro datore di lavoro',
		'EXCEPTION.8006': 'Il dipendente esiste già',
		'EXCEPTION.8007': 'Il token di accesso è vuoto',
		'EXCEPTION.8008': 'Token di accesso non valido',
		'EXCEPTION.8009': 'Deve esistere almeno un amministratore in un\'azienda',
		'EXCEPTION.8010': 'L\'utente può essere collegato solo all\'azienda che lo ha creato.',
		'EXCEPTION.900': 'Non esiste',
		'EXCEPTION.9000': 'L\'ora di inizio è vuota o futura',
		'EXCEPTION.9001': 'Il tempo di arresto è vuoto o futuro',
		'EXCEPTION.9002': 'Il tempo di arresto è uguale o inferiore al tempo di avvio',
		'EXCEPTION.9003': 'Il conducente non è un dipendente del titolare del posto di lavoro',
		'EXCEPTION.9004': 'L\'implementazione non appartiene al titolare del lavoro',
		'EXCEPTION.9005': 'Tipo1 non valido',
		'EXCEPTION.9006': 'Tipo2 non valido',
		'EXCEPTION.9007': 'Tipo3 non valido',
		'EXCEPTION.9008': 'Non è possibile generare il lavoro - non ci sono dati grezzi',
		'EXCEPTION.9009': 'Il proprietario della macchina non corrisponde al proprietario dell\'attrezzo',
		'EXCEPTION.901': 'Già esistente',
		'EXCEPTION.9010': 'Lavoro già esistente',
		'EXCEPTION.9012': 'Il lavoro non è pronto',
		'EXCEPTION.9013': 'Il lavoro è contrassegnato per l\'eliminazione',
		'EXCEPTION.9014': 'Il lavoro è archiviato - Non ci sono sedi di lavoro disponibili',
		'EXCEPTION.9015': 'Dati grezzi troppo vecchi',
		'EXCEPTION.9016': 'Almeno un lavoro fa parte di un\'attività',
		'EXCEPTION.9017': 'I lavori non corrispondono (macchina, driver, implementazione devono corrispondere)',
		'EXCEPTION.9018': 'Il divario tra i lavori è troppo grande',
		'EXCEPTION.9019': 'Almeno un lavoro fa parte di un\'attività',
		'EXCEPTION.902': 'Il proprietario non esiste',
		'EXCEPTION.9020': 'Nessun tempo di divisione',
		'EXCEPTION.9021': 'Il tempo di divisione non è superiore all\'ora di inizio e inferiore all\'ora di fine.',
		'EXCEPTION.9022': 'Nessun id di lavoro per la fusione',
		'EXCEPTION.9023': 'Sono richiesti almeno due lavori',
		'EXCEPTION.9024': 'La densità dei punti deve essere maggiore di zero e minore o uguale a uno.',
		'EXCEPTION.903': 'L\'oggetto con l\'id non esiste',
		'EXCEPTION.904': 'Latitudine fuori portata',
		'EXCEPTION.905': 'Longitudine fuori portata',
		'EXCEPTION.906': 'Il proprietario non corrisponde',
		'EXCEPTION.907': 'Il parametro è vuoto',
		'EXCEPTION.99': 'Parametro non valido',
		'EXPORT': 'Esportazione',
		'EXPORT.FILTERED_JOBS': 'Esportazione di tutti i lavori filtrati',
		'EXPORT.JOB_DETAILS': 'Esportazione dei dettagli del lavoro',
		'EXPORT.OPERATIONS.CUSTOMER.PERIOD': 'Esportazione di tutti i dati del cliente nel periodo selezionato',
		'EXPORT.OPERATIONS.FIELDS.PERIOD': 'Esportazione di tutte le operazioni sui campi nel periodo selezionato',
		'EXPORT.OPERATIONS.LOCATIONS.PERIOD': 'Esportazione di tutte le operazioni sulle sedi nel periodo selezionato',
		'EXPORT.POINTS': 'Punti dati',
		'EXPORT.POLYGONS': 'Poligoni',
		'EXPORT.RAW_DATA_AS_SILO': 'Esportazione dei dati grezzi del lavoro come file SILO',
		'EXPORT.SELECTED': 'Esportazione selezionata',
		'EXPORT.SELECT_DATA': 'Selezionare i dati che devono essere inclusi nel rapporto PDF',
		'EXPORT.SELECT_PERIOD': 'Selezionare il periodo da esportare',
		'FIELD': 'Campo',
		'FIELD.ADD': 'Aggiungi campo',
		'FIELD.ADD.SUCCESS': 'Campo aggiunto con successo',
		'FIELD.DEACTIVATE.QUESTION': 'Si vuole davvero disattivare il campo?',
		'FIELD.DEACTIVATE.SUCCESS': 'Campo disattivato con successo',
		'FIELD.DELETE.QUESTION': 'Si vuole davvero eliminare il campo?',
		'FIELD.DELETE.SUCCESS': 'Campo eliminato con successo',
		'FIELD.DETAILS': 'Dettagli del campo',
		'FIELD.DRAW.START': 'Disegnate ora i confini dei campi nella mappa!',
		'FIELD.EDIT.SUCCESS': 'Campo modificato con successo',
		'FIELD.INTERPOLATE': 'Interpolare',
		'FIELD.INTERPOLATED_VALUES': 'Valori interpolati',
		'FIELD.INTERPOLATION': 'Interpolazione',
		'FIELD.INTERPOLATION_SETTINGS': 'Impostazioni di interpolazione',
		'FIELD.INTERPOLATION_SETTINGS.FINE': 'Fine',
		'FIELD.INTERPOLATION_SETTINGS.FINE+': 'Molto fine',
		'FIELD.INTERPOLATION_SETTINGS.ROUGH': 'Grezzo',
		'FIELD.INTERPOLATION_SETTINGS.STANDARD': 'Standard',
		'FIELD.NUMBER': 'Numero di campo',
		'FIELD.PROCESSED': 'Campo processato',
		'FIELDS': 'Campi',
		'FIELDS.ALL': 'Tutti i campi',
		'FIELDS.DEACTIVATE.FAILURE': 'Non è stato possibile disattivare alcuni campi.',
		'FIELDS.DEACTIVATE.QUESTION': 'Si desidera davvero disattivare i campi?',
		'FIELDS.DEACTIVATE.SUCCESS': 'Campi disattivati con successo',
		'FIELDS.DELETE.FAILURE': 'Non è stato possibile eliminare alcuni campi.',
		'FIELDS.DELETE.QUESTION': 'Si desidera davvero eliminare i campi selezionati?',
		'FIELDS.DELETE.SUCCESS': 'I campi sono stati eliminati con successo',
		'FIELDS.EDIT': 'Modifica dei campi',
		'FIELDS.IMPORT': 'Campi di importazione',
		'FIELDS.IMPORT.ASSIGN_CUSTOMER.QUESTION': 'Si vuole assegnare un cliente ai campi selezionati?',
		'FIELDS.IMPORT.SHAPE': 'Selezionare un file SHAPE da importare.',
		'FIELDS.IMPORT.SUCCESS': 'Campi importati con successo',
		'FIELDS.MANAGEMENT': 'Gestione dei campi',
		'FIELDS.NO': 'Nessun campo',
		'FIELDS.NOT_SELECTED': 'Nessun campo selezionato',
		'FIELDS.REACTIVATE.FAILURE': 'Alcuni campi non potevano essere riattivati.',
		'FIELDS.REACTIVATE.QUESTION': 'Si desidera davvero riattivare i campi selezionati?',
		'FIELDS.REACTIVATE.SUCCESS': 'Campi riattivati con successo',
		'FIELDS.SELECT': 'Seleziona i campi',
		'FIELDS.SELECTED': 'Campi selezionati',
		'FILE': 'File',
		'FILE.GENERATING': 'Il file viene generato e aggiunto a breve al file manager.',
		'FILE.GENERATING.READY': 'Un nuovo file è pronto per essere scaricato',
		'FILE.MANAGER': 'Gestore di file',
		'FILE.NO_FILES': 'Nessun file esistente',
		'FILE.UPLOAD': 'Caricare il file',
		'FILE_TRANSFER': 'Gestione di ISOTaskData',
		'FILE_TRANSFER.ADD': 'Aggiungere ISOTaskData',
		'FILE_TRANSFER.ADD.SUCCESS': 'ISOTaskData aggiunto con successo',
		'FILE_TRANSFER.CREATE': 'Aggiungere ISOTaskData',
		'FILE_TRANSFER.DELETE.QUESTION': 'Si vuole davvero eliminare ISOTaskData?',
		'FILE_TRANSFER.DELETE.SUCCESS': 'ISOTaskData eliminato con successo',
		'FILE_TRANSFER.FINISHED_TASKS': 'Attività pronte',
		'FILE_TRANSFER.NO': 'Nessun ISOTaskData',
		'FILE_TRANSFER.QUEUED_TASKS': 'Attività in coda',
		'FILTER': 'Filtro',
		'FIRMWARE_VERSION': 'Versione del firmware',
		'FIRSTNAME': 'Nome',
		'FORMS.FILE_TOO_LARGE': 'Il file è troppo grande.',
		'FORMS.NO_PASSWORD_MATCH': 'Le password non corrispondono!',
		'FORMS.REQUIRED': 'Richiesto',
    'FORMS.INVALID_EMAIL': 'Indirizzo email non valido',
		'FORMULA': 'Formula',
		'FUEL': 'Carburante',
		'FUEL.CONSUMPTION': 'Consumo di carburante',
		'FUEL.CONSUMPTION.AREA': 'Consumo di carburante per area',
		'FUEL.CONSUMPTION.AVERAGE': 'Consumo medio di carburante',
		'FUEL.CONSUMPTION.OVERALL': 'Consumo complessivo di carburante',
		'FUEL.CONSUMPTION.TOTAL': 'Consumo totale di carburante',
		'FUEL.COST': 'Costo del carburante',
		'FUEL.LEVEL': 'Livello del carburante',
		'FUEL.PRICE_PER_LITER': 'Prezzo del carburante al litro',
		'FUEL.WARNING': 'Livello di carburante basso!',
		'GENERAL_INSPECTION': 'Ispezione generale',
		'GEOMETRIES.UPDATE': 'Aggiornare i campi e le posizioni',
		'GEOMETRY.ADD.REGENERATION_NEEDED': 'Tutti i dati sottostanti devono essere aggiornati per assegnarli correttamente dopo l\'aggiunta di una nuova geometria. Si desidera aggiornare i dati ora?',
		'GEOMETRY.CLICK_TO_SAVE': 'Per salvare, fare clic sulla mappa.',
		'GPS': 'GPS',
		'GPS.GPS': 'GPS interno',
		'GPS.LP': 'Ultima posizione conosciuta',
		'GPS.RTK': 'RTK',
		'GPS.RTK_H': 'RTK (alta precisione)',
		'GPS.STATUS': 'Stato del GPS',
		'GPS_HITCH_DISTANCE.IMPLEMENT.INFO': 'For recording the machine track correctly you need to input the distance between the hitch (A) and the point of application of the implement (B). The distance is measured in cm.',
		'GPS_HITCH_DISTANCE.MACHINE.INFO': 'For recording the machine track correctly you need to input the distance between the GPS receiver (A) and the hitch of the machine (B). The distance is measured in cm.',
		'GPS_TO_HITCH_DISTANCE': 'Distanza tra GPS e gancio',
		'HARDWARE': 'Hardware',
		'HARDWARE.SETUP.PRINT_STICKER': 'Stampa dell\'adesivo hardware',
		'HARDWARE.SETUP.PRINT_STICKER_PACKAGING': 'Stampa dell\'adesivo della confezione',
		'HARDWARE.SETUP.RESET_DEVICE': 'Azzeramento del dispositivo',
		'HARDWARE.SETUP.SET_SERIAL': 'Imposta seriale',
		'HEADLAND.PASSES': 'Headland passes',
		'HELPER_MODEL_TEXT': 'Modello secondo l\'input',
		'HITCH_TO_APPLICATION_DISTANCE': 'Distanza tra il gancio e l\'applicazione',
		'HINT_MARKERS.SHOW': 'Mostra marcatori suggerimenti',
		'HOME': 'Benvenuti',
		'HOME.CONTACTREPLY1': 'Allora non esitate a chiamarci al numero',
		'HOME.CONTACTREPLY2': 'oppure inviateci un\'e-mail a',
		'HOME.INTRODUCTORY_VIDEOS': 'Video introduttivi',
		'HOME.NEWSINFO1': 'Tutte le novità e le informazioni interessanti sulla gestione della flotta e sulla localizzazione delle macchine sono disponibili sul nostro sito web',
		'HOME.NEWSINFO2': 'o sul nostro',
		'HOME.PROFILEEXPLANATION': 'Alla voce \"Il mio profilo\" è possibile modificare i propri dati personali, l\'e-mail e la password.',
		'HOME.QUESTIONSYSTEM': 'Avete domande sul nostro sistema?',
		'HOME.TITLE': 'Benvenuti',
		'HOME.WELCOMEAREA': 'Benvenuti nella vostra zona!',
		'IDLE': 'Inattivo',
		'IGNORE': 'Ignorare',
		'IMPLEMENT': 'Attuare',
		'IMPLEMENT.ADD': 'Aggiungere l\'implementazione',
		'IMPLEMENT.ADD.SUCCESS': 'Implementazione aggiunta con successo',
		'IMPLEMENT.CLASS': 'Implementare la classe',
		'IMPLEMENT.DELETE.QUESTION': 'Volete davvero cancellare l\'applicazione?',
		'IMPLEMENT.DELETE.SUCCESS': 'Implementazione cancellata con successo',
		'IMPLEMENT.DETAILS': 'Implementare i dettagli',
		'IMPLEMENT.EDIT': 'Modifica implementazione',
		'IMPLEMENT.EDIT.SUCCESS': 'Attuazione modificata con successo',
		'IMPLEMENT.FIXED': 'Implementazione fissa',
		'IMPLEMENT.NO': 'Nessuna implementazione',
		'IMPLEMENT.PROCESS.0': 'Nessuna implementazione',
		'IMPLEMENT.PROCESS.1': 'Preparazione delle balle rotonde',
		'IMPLEMENT.PROCESS.10': 'Rotolamento',
		'IMPLEMENT.PROCESS.11': 'Semina',
		'IMPLEMENT.PROCESS.12': 'Piantagione',
		'IMPLEMENT.PROCESS.13': 'Concimazione',
		'IMPLEMENT.PROCESS.14': 'Spruzzatura',
		'IMPLEMENT.PROCESS.15': 'Irrigazione',
		'IMPLEMENT.PROCESS.16': 'Falciatura',
		'IMPLEMENT.PROCESS.17': 'Tornitura dell\'erba',
		'IMPLEMENT.PROCESS.18': 'Trasporto',
		'IMPLEMENT.PROCESS.19': 'Spazzatura',
		'IMPLEMENT.PROCESS.2': 'La pressatura di balle quadrate',
		'IMPLEMENT.PROCESS.20': 'Spalatura della neve',
		'IMPLEMENT.PROCESS.21': 'Spargimento di sale',
		'IMPLEMENT.PROCESS.22': 'Zappatura',
		'IMPLEMENT.PROCESS.23': 'Fertilizzazione',
		'IMPLEMENT.PROCESS.24': 'Pompaggio di liquami',
		'IMPLEMENT.PROCESS.25': 'Miscelazione di fanghi',
		'IMPLEMENT.PROCESS.26': 'Piantare le patate',
		'IMPLEMENT.PROCESS.27': 'Piantare le patate',
		'IMPLEMENT.PROCESS.28': 'Separazione',
		'IMPLEMENT.PROCESS.29': 'Formazione del crinale',
		'IMPLEMENT.PROCESS.3': 'Fasciatura in balle',
		'IMPLEMENT.PROCESS.30': 'Topping Haulm',
		'IMPLEMENT.PROCESS.31': 'Andanatura',
		'IMPLEMENT.PROCESS.32': 'Straziante',
		'IMPLEMENT.PROCESS.33': 'Straziante',
		'IMPLEMENT.PROCESS.34': 'Tritare',
		'IMPLEMENT.PROCESS.35': 'Spazzatura',
		'IMPLEMENT.PROCESS.36': 'Soffiare la neve',
		'IMPLEMENT.PROCESS.37': 'Spostamento dei contenitori di liquame',
		'IMPLEMENT.PROCESS.38': ' Bed forming ',
		'IMPLEMENT.PROCESS.39': 'Alimentazione',
		'IMPLEMENT.PROCESS.4': 'Avvolgimento delle balle',
		'IMPLEMENT.PROCESS.40': 'Spostare il legno',
		'IMPLEMENT.PROCESS.41': 'Segare il legno',
		'IMPLEMENT.PROCESS.42': 'Legno spaccato',
		'IMPLEMENT.PROCESS.43': 'Fresatura di ceppi d\'albero',
		'IMPLEMENT.PROCESS.44': 'Caricamento di materiale sfuso',
		'IMPLEMENT.PROCESS.45': 'Caricamento dei pallet',
		'IMPLEMENT.PROCESS.46': 'Caricamento delle balle',
		'IMPLEMENT.PROCESS.47': 'I mulini CCM convertono',
		'IMPLEMENT.PROCESS.48': 'Spingere',
		'IMPLEMENT.PROCESS.49': 'Peso anteriore/posteriore',
		'IMPLEMENT.PROCESS.5': 'Aratura',
		'IMPLEMENT.PROCESS.50': 'Trebbiatura',
		'IMPLEMENT.PROCESS.51': 'Tritatura',
		'IMPLEMENT.PROCESS.52': 'Pressatura di balle ad alta pressione',
		'IMPLEMENT.PROCESS.53': 'Svolgimento',
		'IMPLEMENT.PROCESS.54': 'Pianificazione',
		'IMPLEMENT.PROCESS.55': 'Lavorazione del suolo',
		'IMPLEMENT.PROCESS.56': 'Toelettatura',
		'IMPLEMENT.PROCESS.57': 'Lavoro di assemblaggio',
		'IMPLEMENT.PROCESS.58': 'Intraprendere',
		'IMPLEMENT.PROCESS.59': 'Carico e scarico',
		'IMPLEMENT.PROCESS.6': 'Coltivare',
		'IMPLEMENT.PROCESS.60': 'Lavaggio',
		'IMPLEMENT.PROCESS.61': 'Compattazione',
		'IMPLEMENT.PROCESS.7': 'Straziante',
		'IMPLEMENT.PROCESS.8': 'Allentamento profondo',
		'IMPLEMENT.PROCESS.9': 'Potenza straziante',
		'IMPLEMENT.PROCESS.deadhead': 'Nessuna implementazione',
		'IMPLEMENT.REMOVE': 'Rimuovere l\'attrezzo',
		'IMPLEMENT.RESOURCE.0': 'Non definito',
		'IMPLEMENT.RESOURCE.1': 'Foraggio',
		'IMPLEMENT.RESOURCE.10': 'Letame',
		'IMPLEMENT.RESOURCE.11': 'Liquami',
		'IMPLEMENT.RESOURCE.12': 'Compost',
		'IMPLEMENT.RESOURCE.13': 'Digestato',
		'IMPLEMENT.RESOURCE.14': 'Trucioli di legno',
		'IMPLEMENT.RESOURCE.15': 'Mais',
		'IMPLEMENT.RESOURCE.16': 'Girasole',
		'IMPLEMENT.RESOURCE.17': 'Sorgo',
		'IMPLEMENT.RESOURCE.18': 'Segale',
		'IMPLEMENT.RESOURCE.19': 'Triticale',
		'IMPLEMENT.RESOURCE.2': 'Insilati di prato',
		'IMPLEMENT.RESOURCE.20': 'Grano',
		'IMPLEMENT.RESOURCE.21': 'Fagiolo di campo',
		'IMPLEMENT.RESOURCE.22': 'Pisello',
		'IMPLEMENT.RESOURCE.23': 'Prato',
		'IMPLEMENT.RESOURCE.24': 'Trifoglio',
		'IMPLEMENT.RESOURCE.25': 'Orzo',
		'IMPLEMENT.RESOURCE.26': 'Avena',
		'IMPLEMENT.RESOURCE.27': 'Farro',
		'IMPLEMENT.RESOURCE.28': 'Camelina',
		'IMPLEMENT.RESOURCE.29': 'Semi di lino',
		'IMPLEMENT.RESOURCE.3': 'Insilati di piante intere',
		'IMPLEMENT.RESOURCE.30': 'Colza',
		'IMPLEMENT.RESOURCE.31': 'Semi di soia',
		'IMPLEMENT.RESOURCE.32': 'Coltura di cattura',
		'IMPLEMENT.RESOURCE.33': 'Barbabietola da zucchero',
		'IMPLEMENT.RESOURCE.34': 'Patate',
		'IMPLEMENT.RESOURCE.35': 'Miscanto',
		'IMPLEMENT.RESOURCE.36': 'Topinambur',
		'IMPLEMENT.RESOURCE.37': 'Verdure',
		'IMPLEMENT.RESOURCE.38': 'Fragole',
		'IMPLEMENT.RESOURCE.39': 'Fertilizzante liquido',
		'IMPLEMENT.RESOURCE.4': 'Fieno',
		'IMPLEMENT.RESOURCE.40': 'Calce',
		'IMPLEMENT.RESOURCE.41': 'Diammonphosphat ',
		'IMPLEMENT.RESOURCE.42': 'Pellet di farina di Haar, PK, K, P, KAS',
		'IMPLEMENT.RESOURCE.43': 'Urea',
		'IMPLEMENT.RESOURCE.44': 'Diesel ',
		'IMPLEMENT.RESOURCE.45': ' AdBlue ',
		'IMPLEMENT.RESOURCE.46': 'Terra',
		'IMPLEMENT.RESOURCE.47': 'Protettivo per le piante',
		'IMPLEMENT.RESOURCE.48': 'Varie',
		'IMPLEMENT.RESOURCE.49': 'Acqua',
		'IMPLEMENT.RESOURCE.5': 'CCM ',
		'IMPLEMENT.RESOURCE.50': 'Miscela di mangimi',
		'IMPLEMENT.RESOURCE.6': 'Mais',
		'IMPLEMENT.RESOURCE.7': 'Paglia',
		'IMPLEMENT.RESOURCE.8': 'Insilato di mais',
		'IMPLEMENT.RESOURCE.9': 'Grano',
		'IMPLEMENT.TYPE': 'Tipo di implementazione',
		'IMPLEMENT.TYPE.1': 'Presse / Avvolgitrici',
		'IMPLEMENT.TYPE.10': 'Rimorchi per il trasporto',
		'IMPLEMENT.TYPE.10_1': 'Ribaltabile a tre vie',
		'IMPLEMENT.TYPE.10_10': 'Rimorchio a pianale ribassato',
		'IMPLEMENT.TYPE.10_11': 'Gancio di sollevamento del rimorchio',
		'IMPLEMENT.TYPE.10_12': 'Rimorchio per bestiame',
		'IMPLEMENT.TYPE.10_13': 'Carrello per semirimorchio',
		'IMPLEMENT.TYPE.10_14': 'Cisterna/Silo camion ',
		'IMPLEMENT.TYPE.10_2': 'Corpo ribaltabile',
		'IMPLEMENT.TYPE.10_3': 'Cestino Chaser',
		'IMPLEMENT.TYPE.10_4': 'Trailer della piattaforma',
		'IMPLEMENT.TYPE.10_5': 'Carro per foraggio',
		'IMPLEMENT.TYPE.10_6': 'Rimorchio per insilati',
		'IMPLEMENT.TYPE.10_7': 'Rimorchio per trasporto balle',
		'IMPLEMENT.TYPE.10_8': 'Rimorchio a spinta',
		'IMPLEMENT.TYPE.10_9': 'Cisterna per letame liquido',
		'IMPLEMENT.TYPE.11': 'Attrezzature per il bestiame',
		'IMPLEMENT.TYPE.11_1': 'Miscelatore con alimentazione trainata',
		'IMPLEMENT.TYPE.11_2': 'Carro per la distribuzione del foraggio',
		'IMPLEMENT.TYPE.11_3': 'Carro di raccolta/distribuzione',
		'IMPLEMENT.TYPE.12': 'Silvicoltura',
		'IMPLEMENT.TYPE.12_1': 'Trailer della foresta',
		'IMPLEMENT.TYPE.12_2': 'Sega per legna da ardere',
		'IMPLEMENT.TYPE.12_3': 'Trasformatore di legna da ardere',
		'IMPLEMENT.TYPE.12_4': 'Spaccalegna',
		'IMPLEMENT.TYPE.12_5': 'Smerigliatrice di ceppi',
		'IMPLEMENT.TYPE.12_6': 'Argano forestale',
		'IMPLEMENT.TYPE.12_7': 'Trinciatrice forestale',
		'IMPLEMENT.TYPE.12_8': 'Cippatrice per legno',
		'IMPLEMENT.TYPE.12_8_1': 'Cippatrice a disco montata',
		'IMPLEMENT.TYPE.12_8_2': 'Cippatrice a disco trainata',
		'IMPLEMENT.TYPE.12_8_3': 'Cippatrice a tamburo montata',
		'IMPLEMENT.TYPE.12_8_4': 'Cippatrice a tamburo trainata',
		'IMPLEMENT.TYPE.12_8_5': 'Cippatrice a tamburo trainata (semovente)',
		'IMPLEMENT.TYPE.12_9': 'Tagliasiepi idraulico',
		'IMPLEMENT.TYPE.13': 'Attrezzature municipali',
		'IMPLEMENT.TYPE.13_1': 'Spazzatrici',
		'IMPLEMENT.TYPE.13_10': 'Dispositivo di manutenzione dei sentieri',
		'IMPLEMENT.TYPE.13_11': 'Fresatrice per banchetti',
		'IMPLEMENT.TYPE.13_12': 'Salsiera - allegata',
		'IMPLEMENT.TYPE.13_13': 'Caricatore',
		'IMPLEMENT.TYPE.13_14': 'Dispositivo di lavaggio',
		'IMPLEMENT.TYPE.13_15': 'Dispositivo di irrigazione',
		'IMPLEMENT.TYPE.13_16': 'Piattaforma di lavoro',
		'IMPLEMENT.TYPE.13_17': 'Pacciamatore di superficie',
		'IMPLEMENT.TYPE.13_18': 'Frontale a sbalzo',
		'IMPLEMENT.TYPE.13_18_1': 'Testa di taglio',
		'IMPLEMENT.TYPE.13_18_2': 'Testa di pacciamatura',
		'IMPLEMENT.TYPE.13_18_3': 'Tagliasiepi',
		'IMPLEMENT.TYPE.13_18_4': 'Cestino di pulizia',
		'IMPLEMENT.TYPE.13_18_5': 'Rastrello',
		'IMPLEMENT.TYPE.13_19': 'Centro/struttura stabilizzatore',
		'IMPLEMENT.TYPE.13_19_1': 'Testa di taglio',
		'IMPLEMENT.TYPE.13_19_2': 'Testa di pacciamatura',
		'IMPLEMENT.TYPE.13_19_3': 'Tagliasiepi',
		'IMPLEMENT.TYPE.13_19_4': 'Cestino di pulizia',
		'IMPLEMENT.TYPE.13_19_5': 'Rastrello',
		'IMPLEMENT.TYPE.13_1_1': 'Spazzatrice anteriore',
		'IMPLEMENT.TYPE.13_1_2': 'Spazzatrice posteriore',
		'IMPLEMENT.TYPE.13_1_3': 'Struttura',
		'IMPLEMENT.TYPE.13_2': 'Spazzaneve',
		'IMPLEMENT.TYPE.13_20': 'Parte posteriore del braccio',
		'IMPLEMENT.TYPE.13_20_1': 'Testa di taglio',
		'IMPLEMENT.TYPE.13_20_2': 'Testa di pacciamatura',
		'IMPLEMENT.TYPE.13_20_3': 'Tagliasiepi',
		'IMPLEMENT.TYPE.13_20_4': 'Cestino di pulizia',
		'IMPLEMENT.TYPE.13_20_5': 'Rastrello',
		'IMPLEMENT.TYPE.13_21': 'Soffiatore per foglie',
		'IMPLEMENT.TYPE.13_22': 'Compattatore per banchetti / compattatore di piatti',
		'IMPLEMENT.TYPE.13_3': 'Spazzaneve - forma a V',
		'IMPLEMENT.TYPE.13_4': 'Fresa da neve',
		'IMPLEMENT.TYPE.13_5': 'Spargitore montato',
		'IMPLEMENT.TYPE.13_6': 'Spargitore trainato',
		'IMPLEMENT.TYPE.13_7': 'Falciatrice stradale',
		'IMPLEMENT.TYPE.13_8': 'Falciatrice outrigger',
		'IMPLEMENT.TYPE.13_9': 'Falciatrice',
		'IMPLEMENT.TYPE.14': 'Attrezzatura a carico frontale',
		'IMPLEMENT.TYPE.14_1': 'Secchio',
		'IMPLEMENT.TYPE.14_2': 'Secchio (alto volume)',
		'IMPLEMENT.TYPE.14_3': 'Forca per pallet',
		'IMPLEMENT.TYPE.14_4': 'Pinza per balle',
		'IMPLEMENT.TYPE.14_5': 'Forca per balle',
		'IMPLEMENT.TYPE.14_6': 'Secchio di raccolta',
		'IMPLEMENT.TYPE.14_7': 'Piattaforma di lavoro',
		'IMPLEMENT.TYPE.14_8': 'Forca per letame',
		'IMPLEMENT.TYPE.15': 'Raccolta degli allegati',
		'IMPLEMENT.TYPE.15_1': 'Taglio',
		'IMPLEMENT.TYPE.15_1_1': 'Standard di taglio',
		'IMPLEMENT.TYPE.15_1_2': 'Taglio pieghevole',
		'IMPLEMENT.TYPE.15_2': 'Raccoglitore di mais',
		'IMPLEMENT.TYPE.15_2_1': 'Raccoglitore di mais standard',
		'IMPLEMENT.TYPE.15_3': 'Testata di mais',
		'IMPLEMENT.TYPE.15_4': 'Attacco per l\'insilamento di piante intere',
		'IMPLEMENT.TYPE.15_5': 'Ritiro',
		'IMPLEMENT.TYPE.15_6': 'Cancellazione dell\'allegato',
		'IMPLEMENT.TYPE.15_7': 'Sistema di aspirazione',
		'IMPLEMENT.TYPE.15_8': 'Raccolta dell\'andana',
		'IMPLEMENT.TYPE.16': 'Varie',
		'IMPLEMENT.TYPE.16_1': 'Mulino per l\'ammasso CCM',
		'IMPLEMENT.TYPE.16_2': 'Peso anteriore',
		'IMPLEMENT.TYPE.16_3': 'Peso posteriore',
		'IMPLEMENT.TYPE.16_4': 'Lama di spinta',
		'IMPLEMENT.TYPE.17': 'Frutteto e vigneto',
		'IMPLEMENT.TYPE.17_1': 'Aratro di sgombero',
		'IMPLEMENT.TYPE.17_2': 'Macchina per la semina',
		'IMPLEMENT.TYPE.17_3': 'Defogliatore',
		'IMPLEMENT.TYPE.17_4': 'Fresatrice per barbatelle',
		'IMPLEMENT.TYPE.18': 'Coltivazione di ortaggi',
		'IMPLEMENT.TYPE.18_1': 'Raccoglitore di carote',
		'IMPLEMENT.TYPE.18_2': 'Raccoglitore di cipolle',
		'IMPLEMENT.TYPE.18_4': 'Raccoglitore di bulbi',
		'IMPLEMENT.TYPE.18_5': 'Raccoglitore di porri',
		'IMPLEMENT.TYPE.19': 'Tecnologia della barbabietola da zucchero',
		'IMPLEMENT.TYPE.19_1': 'Raccoglitrice di barbabietole da zucchero - raccoglitrice a bunker',
		'IMPLEMENT.TYPE.19_1_1': 'Raccoglitore di bunker',
		'IMPLEMENT.TYPE.19_1_2': 'Sovraccaricatore',
		'IMPLEMENT.TYPE.1_1': 'Rotopressa',
		'IMPLEMENT.TYPE.1_2': 'Pressa quadra',
		'IMPLEMENT.TYPE.1_3': 'Combinazione di pressatura e fasciatura',
		'IMPLEMENT.TYPE.1_4': 'Avvolgitore per balle',
		'IMPLEMENT.TYPE.1_5': 'Pressa ad alta densità',
		'IMPLEMENT.TYPE.2': 'Coltivazione del suolo',
		'IMPLEMENT.TYPE.2_1': 'Aratro',
		'IMPLEMENT.TYPE.2_10': 'Motocoltivatore',
		'IMPLEMENT.TYPE.2_10_1': 'Motocoltivatore - montato',
		'IMPLEMENT.TYPE.2_10_2': 'Motocoltivatore - allegato',
		'IMPLEMENT.TYPE.2_11': 'Impacchettatore frontale',
		'IMPLEMENT.TYPE.2_12': 'Rullo',
		'IMPLEMENT.TYPE.2_12_1': 'Rullo - montato',
		'IMPLEMENT.TYPE.2_12_2': 'Rullo - allegato',
		'IMPLEMENT.TYPE.2_13': 'Erpici rotanti',
		'IMPLEMENT.TYPE.2_13_1': 'Erpici rotanti - montati',
		'IMPLEMENT.TYPE.2_13_2': 'Erpici rotanti - allegati',
		'IMPLEMENT.TYPE.2_14': 'Coltivatore rotante',
		'IMPLEMENT.TYPE.2_14_1': 'Coltivatore rotante - montato',
		'IMPLEMENT.TYPE.2_14_2': 'Coltivatore rotante - allegato',
		'IMPLEMENT.TYPE.2_15': 'Combinazione di semenzaio',
		'IMPLEMENT.TYPE.2_15_1': 'Combinazione di semenzaio - montata',
		'IMPLEMENT.TYPE.2_15_2': 'Combinazione del letto di semina - allegato',
		'IMPLEMENT.TYPE.2_16': 'Presse',
		'IMPLEMENT.TYPE.2_17': 'Raschiatori',
		'IMPLEMENT.TYPE.2_17_1': 'Raschiatori- montati',
		'IMPLEMENT.TYPE.2_17_2': 'Raschiatori- allegati',
		'IMPLEMENT.TYPE.2_18': 'Erpice per paglia',
		'IMPLEMENT.TYPE.2_18_1': 'Erpice per paglia - montato',
		'IMPLEMENT.TYPE.2_18_2': 'Erpice per paglia - allegato',
		'IMPLEMENT.TYPE.2_19': 'Altri coltivatori',
		'IMPLEMENT.TYPE.2_19_1': 'Altri coltivatori montati - montati',
		'IMPLEMENT.TYPE.2_19_2': 'Altri coltivatori - allegato',
		'IMPLEMENT.TYPE.2_1_1': 'Aratro montato',
		'IMPLEMENT.TYPE.2_1_2': 'Aratro semiportato',
		'IMPLEMENT.TYPE.2_1_3': 'Aratro semiportato (su terreno)',
		'IMPLEMENT.TYPE.2_2': 'Coltivatore',
		'IMPLEMENT.TYPE.2_20': 'Altri coltivatori',
		'IMPLEMENT.TYPE.2_2_1': 'Coltivatore montato',
		'IMPLEMENT.TYPE.2_2_2': 'Coltivatore trainato',
		'IMPLEMENT.TYPE.2_3': 'Erpice a dischi',
		'IMPLEMENT.TYPE.2_3_1': 'Erpice a dischi montato',
		'IMPLEMENT.TYPE.2_3_2': 'Erpice trainato',
		'IMPLEMENT.TYPE.2_4': 'Erpice a dischi compatto',
		'IMPLEMENT.TYPE.2_4_1': 'Erpice a dischi compatto - montato',
		'IMPLEMENT.TYPE.2_4_2': 'Erpice a disco compatto - allegato',
		'IMPLEMENT.TYPE.2_5': 'Allentatore profondo',
		'IMPLEMENT.TYPE.2_5_1': 'Allentatore profondo - montato',
		'IMPLEMENT.TYPE.2_5_2': 'Allentatore profondo - allegato',
		'IMPLEMENT.TYPE.2_6': 'Vangatrice',
		'IMPLEMENT.TYPE.2_6_1': 'Vangatrice - montata',
		'IMPLEMENT.TYPE.2_6_2': 'Vangatrice - allegato',
		'IMPLEMENT.TYPE.2_7': 'Erpice rotante',
		'IMPLEMENT.TYPE.2_7_1': 'Erpice rotante - montato',
		'IMPLEMENT.TYPE.2_7_2': 'Erpice rotante - allegato',
		'IMPLEMENT.TYPE.2_8': 'Zappatrice rotante',
		'IMPLEMENT.TYPE.2_8_1': 'Zappatrice rotante - montata',
		'IMPLEMENT.TYPE.2_8_2': 'Zappatrice rotante - allegato',
		'IMPLEMENT.TYPE.2_9': 'Erpice alternativo',
		'IMPLEMENT.TYPE.2_9_1': 'Erpice alternativo - montato',
		'IMPLEMENT.TYPE.2_9_2': 'Erpice alternativo - allegato',
		'IMPLEMENT.TYPE.3': 'Seminatrici/piantatrici',
		'IMPLEMENT.TYPE.3_1': 'Seminatrice meccanica',
		'IMPLEMENT.TYPE.3_1_1': 'Seminatrice meccanica - montata',
		'IMPLEMENT.TYPE.3_1_2': 'Seminatrice meccanica - allegata',
		'IMPLEMENT.TYPE.3_1_3': 'Combinazione di semina meccanica - montata',
		'IMPLEMENT.TYPE.3_1_4': 'Combinazione di semina meccanica - allegato',
		'IMPLEMENT.TYPE.3_2': 'Seminatrice pneumatica',
		'IMPLEMENT.TYPE.3_2_1': 'Seminatrice pneumatica - montata',
		'IMPLEMENT.TYPE.3_2_2': 'Seminatrice pneumatica - allegato',
		'IMPLEMENT.TYPE.3_2_3': 'Combinazione di semina pneumatica - montata',
		'IMPLEMENT.TYPE.3_2_4': 'Combinazione di semina pneumatica - allegato',
		'IMPLEMENT.TYPE.3_3': 'Seminatrice meccanica di precisione',
		'IMPLEMENT.TYPE.3_3_1': 'Seminatrice meccanica di precisione - montata',
		'IMPLEMENT.TYPE.3_3_2': 'Seminatrice meccanica di precisione - allegato',
		'IMPLEMENT.TYPE.3_3_3': 'Combinazione di semina meccanica di precisione - montata',
		'IMPLEMENT.TYPE.3_3_4': 'Combinazione di semina meccanica di precisione - allegato',
		'IMPLEMENT.TYPE.3_4': 'Seminatrice pneumatica di precisione',
		'IMPLEMENT.TYPE.3_4_1': 'Seminatrice pneumatica di precisione - montata',
		'IMPLEMENT.TYPE.3_4_2': 'Seminatrice pneumatica di precisione - allegato',
		'IMPLEMENT.TYPE.3_4_3': 'Combinazione di semina pneumatica di precisione - montata',
		'IMPLEMENT.TYPE.3_4_4': 'Combinazione di semina pneumatica di precisione - allegato',
		'IMPLEMENT.TYPE.3_5': 'Seminatrice diretta',
		'IMPLEMENT.TYPE.3_5_1': 'Seminatrice diretta - montata',
		'IMPLEMENT.TYPE.3_5_2': 'Seminatrice diretta - allegato',
		'IMPLEMENT.TYPE.3_6': 'Seminatrice diretta a grano singolo',
		'IMPLEMENT.TYPE.3_6_1': 'Seminatrice diretta a grano singolo - montata',
		'IMPLEMENT.TYPE.3_6_2': 'Seminatrice diretta a grano singolo - allegato',
		'IMPLEMENT.TYPE.3_7': 'Fioriera',
		'IMPLEMENT.TYPE.3_7_1': 'Fioriera - montata',
		'IMPLEMENT.TYPE.3_7_2': 'Fioriera - allegata',
		'IMPLEMENT.TYPE.3_8': 'Seminatrice di prato',
		'IMPLEMENT.TYPE.3_8_1': 'Seminatrice di prato- montata',
		'IMPLEMENT.TYPE.3_8_2': 'Seminatrice di prato- allegato',
		'IMPLEMENT.TYPE.3_9': 'Serbatoio anteriore',
		'IMPLEMENT.TYPE.4': 'Spargitore ',
		'IMPLEMENT.TYPE.4_1': 'Spargitore - montato',
		'IMPLEMENT.TYPE.4_2': 'Spargitore - allegato',
		'IMPLEMENT.TYPE.5': 'Protezione delle piante',
		'IMPLEMENT.TYPE.5_1': 'Spruzzatore - montato',
		'IMPLEMENT.TYPE.5_2': 'Spruzzatore - allegato',
		'IMPLEMENT.TYPE.5_3': 'Zappetta',
		'IMPLEMENT.TYPE.5_3_1': 'Zappetta - montata',
		'IMPLEMENT.TYPE.5_3_2': 'Zappetta - allegato',
		'IMPLEMENT.TYPE.5_4': 'Diserbante',
		'IMPLEMENT.TYPE.5_4_1': 'Diserbante - montata',
		'IMPLEMENT.TYPE.5_4_2': 'Diserbante - allegato',
		'IMPLEMENT.TYPE.6': 'Tecnologia del letame',
		'IMPLEMENT.TYPE.6_1': 'Letame/compost spargitore ',
		'IMPLEMENT.TYPE.6_2': 'Autocisterna per liquami',
		'IMPLEMENT.TYPE.6_2_1': 'Diffusore esatto',
		'IMPLEMENT.TYPE.6_2_2': 'Braccio del tubo gocciolante',
		'IMPLEMENT.TYPE.6_2_3': 'Spargitore a scarpa trainante',
		'IMPLEMENT.TYPE.6_2_4': 'Iniettore del coltivatore',
		'IMPLEMENT.TYPE.6_2_5': 'Iniettore per erpici a dischi',
		'IMPLEMENT.TYPE.6_2_6': 'Iniettore per fresa a disco',
		'IMPLEMENT.TYPE.6_2_7': 'Iniettore striptill',
		'IMPLEMENT.TYPE.6_2_8': 'Distributori girevoli',
		'IMPLEMENT.TYPE.6_3': 'Pompa per liquami',
		'IMPLEMENT.TYPE.6_4': 'Miscelatore di liquami',
		'IMPLEMENT.TYPE.6_5': 'Contenitore per liquami',
		'IMPLEMENT.TYPE.6_6': 'Sistema di tubi flessibili',
		'IMPLEMENT.TYPE.6_6_1': 'Distributore di tubi di trascinamento',
		'IMPLEMENT.TYPE.6_6_2': 'Distributore di pattini di trascinamento',
		'IMPLEMENT.TYPE.6_6_3': 'Iniettore a disco per liquami',
		'IMPLEMENT.TYPE.6_6_4': 'Coltivatore di liquami',
		'IMPLEMENT.TYPE.6_6_5': 'Erpice a dischi per liquami',
		'IMPLEMENT.TYPE.6_6_6': 'Iniettore di liquami',
		'IMPLEMENT.TYPE.6_6_7': 'Distributore girevole',
		'IMPLEMENT.TYPE.7': 'Tecnologia di irrigazione',
		'IMPLEMENT.TYPE.7_1': 'Viaggiatore dell\'irrigazione',
		'IMPLEMENT.TYPE.7_2': 'Barra di irrigazione',
		'IMPLEMENT.TYPE.8': 'Attrezzature per patate',
		'IMPLEMENT.TYPE.8_1': 'Piantatrice di patate',
		'IMPLEMENT.TYPE.8_1_1': 'Seminatrice senza fresa',
		'IMPLEMENT.TYPE.8_1_2': 'Seminatrice con fresa rotante',
		'IMPLEMENT.TYPE.8_1_3': 'Seminatrice senza fresa - allegata',
		'IMPLEMENT.TYPE.8_1_4': 'Seminatrice con fresa rotante - montata',
		'IMPLEMENT.TYPE.8_2': 'Raccoglitrice di patate - andanatrice',
		'IMPLEMENT.TYPE.8_3': 'Raccoglitrice di patate - con bunker',
		'IMPLEMENT.TYPE.8_4': 'Raccoglitrice di patate - elevatore',
		'IMPLEMENT.TYPE.8_5': 'Crinale ',
		'IMPLEMENT.TYPE.8_6': 'Separatore',
		'IMPLEMENT.TYPE.8_7': 'Motocoltivatore',
		'IMPLEMENT.TYPE.8_8': 'Topper Haulm',
		'IMPLEMENT.TYPE.9': 'Attrezzature per il pascolo',
		'IMPLEMENT.TYPE.9_1': 'Falciatrice a tamburo',
		'IMPLEMENT.TYPE.9_1_1': 'Falciatrice a tamburo con condizionatore',
		'IMPLEMENT.TYPE.9_1_2': 'Falciatrice a tamburo senza condizionatore',
		'IMPLEMENT.TYPE.9_1_3': 'Falciatrice a tamburo con condizionatore - montata',
		'IMPLEMENT.TYPE.9_1_4': 'Falciatrice a tamburo senza condizionatore - allegato',
		'IMPLEMENT.TYPE.9_2': 'Falciatrice a disco',
		'IMPLEMENT.TYPE.9_2_1': 'Falciatrice a dischi con condizionatore',
		'IMPLEMENT.TYPE.9_2_2': 'Falciatrice a dischi senza condizionatore',
		'IMPLEMENT.TYPE.9_2_3': 'Falciatrice a dischi con condizionatore - montata',
		'IMPLEMENT.TYPE.9_2_4': 'Falciatrice a dischi senza condizionatore - allegato',
		'IMPLEMENT.TYPE.9_3': 'Spandivoltafieno rotativo ',
		'IMPLEMENT.TYPE.9_3_1': 'Spandivoltafieno rotativo - montato',
		'IMPLEMENT.TYPE.9_3_2': 'Spandivoltafieno rotativo - allegato',
		'IMPLEMENT.TYPE.9_4': 'Piuma',
		'IMPLEMENT.TYPE.9_4_1': 'Ranghinatore a rotore singolo',
		'IMPLEMENT.TYPE.9_4_2': 'Ranghinatore a doppio rotore (posa dell\'andana laterale)',
		'IMPLEMENT.TYPE.9_4_3': 'Ranghinatore a doppio rotore (posa dell\'andana centrale)',
		'IMPLEMENT.TYPE.9_4_4': 'Ranghinatore a quattro rotori',
		'IMPLEMENT.TYPE.9_4_5': 'Fusione continua',
		'IMPLEMENT.TYPE.9_4_6': 'Rastrello rotativo',
		'IMPLEMENT.TYPE.9_5': 'Erpice da prato',
		'IMPLEMENT.TYPE.9_6': 'Erpice da pascolo',
		'IMPLEMENT.TYPE.9_7': 'Rullo per prato',
		'IMPLEMENT.TYPE.9_8': 'Chopper',
		'IMPLEMENTS': 'Implementazioni',
		'IMPLEMENTS.ALL': 'Tutti gli implementazioni',
		'IMPLEMENTS.DEACTIVATE.FAILURE': 'Alcuni attrezzi non potevano essere disattivati.',
		'IMPLEMENTS.DEACTIVATE.QUESTION': 'Volete davvero disattivare gli strumenti selezionati?',
		'IMPLEMENTS.DEACTIVATE.SUCCESS': 'Implementazioni disattivate con successo',
		'IMPLEMENTS.DELETE.FAILURE': 'Non è stato possibile eliminare alcuni implementazioni ',
		'IMPLEMENTS.DELETE.QUESTION': 'Volete davvero eliminare gli implementatori selezionati?',
		'IMPLEMENTS.DELETE.SUCCESS': 'Gli implementazioni sono state cancellate',
		'IMPLEMENTS.MANAGEMENT': 'Gestione degli implementazioni ',
		'IMPLEMENTS.NO': 'Nessuna implementazioni',
		'IMPLEMENTS.NOT_SELECTED': 'Nessun attrezzo selezionato',
		'IMPLEMENTS.REACTIVATE.FAILURE': 'Alcuni attrezzi non potevano essere riattivati.',
		'IMPLEMENTS.REACTIVATE.QUESTION': 'Volete davvero riattivare gli strumenti selezionati?',
		'IMPLEMENTS.REACTIVATE.SUCCESS': 'Implementazioni riattivate con successo',
		'IMPLEMENTS.SELECTED': 'Implementazioni selezionate',
		'IMPLEMENT_SCAN_DISABLED': 'Implementare la scansione beacon inattiva',
		'IMPORT': 'Importazione',
		'INACTIVE': 'Inattivo',
		'INDIVIDUAL_LABELING': 'Etichettatura personalizzata',
		'INFO': 'Informazioni',
		'INTERPOLATION.MAP': 'Mappa di interpolazione',
		'INTERPOLATION.MAP.SETTINGS': 'Impostazioni della mappa di interpolazione',
		'IO_BOX_ACTIVATED': 'IOBox attivo',
		'ISOBUS.DDI.1': 'Valore nominale: Volume per Area di Tasso di Applicazione',
		'ISOBUS.DDI.10': 'Massa massima per area di tasso di applicazione',
		'ISOBUS.DDI.100': 'Contaminazione delle colture',
		'ISOBUS.DDI.101': 'Valore nominale della larghezza della balla',
		'ISOBUS.DDI.102': 'Larghezza effettiva della balla',
		'ISOBUS.DDI.103': 'Larghezza predefinita della balla',
		'ISOBUS.DDI.104': 'Larghezza minima della balla',
		'ISOBUS.DDI.105': 'Larghezza massima della balla',
		'ISOBUS.DDI.106': 'Valore nominale dell\'altezza della balla',
		'ISOBUS.DDI.107': 'Altezza effettiva della balla',
		'ISOBUS.DDI.108': 'Altezza predefinita della balla',
		'ISOBUS.DDI.109': 'Altezza minima della balla',
		'ISOBUS.DDI.11': 'Conteggio del valore nominale per area di tasso di applicazione',
		'ISOBUS.DDI.110': 'Altezza massima della balla',
		'ISOBUS.DDI.111': 'Valore nominale della dimensione della balla',
		'ISOBUS.DDI.112': 'Dimensioni effettive della balla',
		'ISOBUS.DDI.113': 'Dimensione predefinita della balla',
		'ISOBUS.DDI.114': 'Dimensione minima della balla',
		'ISOBUS.DDI.115': 'Dimensione massima della balla',
		'ISOBUS.DDI.116': 'Area totale',
		'ISOBUS.DDI.117': 'Distanza totale effettiva',
		'ISOBUS.DDI.118': 'Distanza totale inefficace',
		'ISOBUS.DDI.119': 'Tempo totale effettivo',
		'ISOBUS.DDI.12': 'Conteggio effettivo per area di tasso di applicazione',
		'ISOBUS.DDI.120': 'Tempo totale inefficace',
		'ISOBUS.DDI.121': 'Densità del prodotto di massa per volume',
		'ISOBUS.DDI.122': 'Densità dei prodotti en massa perconto',
		'ISOBUS.DDI.123': 'Densità del prodotto en volume per conta',
		'ISOBUS.DDI.124': 'Scala della valvola ausiliaria estensione',
		'ISOBUS.DDI.125': 'Scala della valvola ausiliaria ritirata',
		'ISOBUS.DDI.126': 'Rampa della valvola ausiliaria estensione verso l\'alto',
		'ISOBUS.DDI.127': 'Rampa della valvola ausiliaria estensione verso il basso',
		'ISOBUS.DDI.128': 'Rampa della valvola ausiliaria- Ritirata in alto',
		'ISOBUS.DDI.129': 'Rampa della valvola ausiliaria- Ritirata in bajjo',
		'ISOBUS.DDI.13': 'Conteggio predefinito per area di tasso di applicazione',
		'ISOBUS.DDI.130': 'Soglia di galleggiamento della valvola ausiliaria',
		'ISOBUS.DDI.131': 'Valvola ausiliaria- Progressività Estendere',
		'ISOBUS.DDI.132': 'Valvola ausiliaria- Ritrazione progressiva',
		'ISOBUS.DDI.133': 'Porte di inversione della valvola ausiliaria',
		'ISOBUS.DDI.134': 'Elemento dispositivo Offset X',
		'ISOBUS.DDI.135': 'Offset elemento dispositivo Y',
		'ISOBUS.DDI.136': 'Offset elemento dispositivo Z',
		'ISOBUS.DDI.137': 'Capacità del volume del dispositivo',
		'ISOBUS.DDI.138': 'Capacità di massa del dispositivo',
		'ISOBUS.DDI.139': 'Capacità di conteggio dei dispositivi',
		'ISOBUS.DDI.14': 'Conteggio minimo per area di tasso di applicazione',
		'ISOBUS.DDI.140': 'Valore nominale di tasso di applicazione percentuale ',
		'ISOBUS.DDI.141': 'Stato di lavoro effettivo',
		'ISOBUS.DDI.142': 'Valore nominale fisico del tempo di latenza',
		'ISOBUS.DDI.143': 'Valore effettivo fisico del tempo di latenza',
		'ISOBUS.DDI.144': 'Angolo d\'imbardata',
		'ISOBUS.DDI.145': 'Angolo di rotazione',
		'ISOBUS.DDI.146': 'Angolo di inclinazione',
		'ISOBUS.DDI.147': 'Conteggio registri',
		'ISOBUS.DDI.148': 'Consumo totale di carburante',
		'ISOBUS.DDI.149': 'Consumo di carburante per tempo',
		'ISOBUS.DDI.15': 'Conteggio massimo per area di tasso di applicazione',
		'ISOBUS.DDI.150': 'Consumo di carburante per area',
		'ISOBUS.DDI.151': 'Area per capacità di tempo',
		'ISOBUS.DDI.153': 'Indice vegetativo differenziale normalizzato (NDVI) effettivo',
		'ISOBUS.DDI.154': 'Lunghezza dell\'oggetto fisico',
		'ISOBUS.DDI.155': 'Larghezza dell\'oggetto fisico',
		'ISOBUS.DDI.156': 'Altezza dell\'oggetto fisico',
		'ISOBUS.DDI.157': 'Tipo di connettore',
		'ISOBUS.DDI.158': 'Stato di controllo delle prescrizioni',
		'ISOBUS.DDI.159': 'Numero di sottounità per sezione',
		'ISOBUS.DDI.16': 'Spaziatura del valore nominale di velocità di applicazione',
		'ISOBUS.DDI.160': 'Stato di controllo della sezione',
		'ISOBUS.DDI.161': 'Stato di lavoro effettivo condensato (1-16)',
		'ISOBUS.DDI.162': 'Stato di lavoro effettivo condensato (17-32)',
		'ISOBUS.DDI.163': 'Stato di lavoro effettivo condensato (33-48)',
		'ISOBUS.DDI.164': 'Stato di lavoro effettivo condensato (49-64)',
		'ISOBUS.DDI.165': 'Stato di lavoro effettivo condensato (65-80)',
		'ISOBUS.DDI.166': 'Stato di lavoro effettivo condensato (81-96)',
		'ISOBUS.DDI.167': 'Stato di lavoro effettivo condensato (97-112)',
		'ISOBUS.DDI.168': 'Stato di lavoro effettivo condensato (113-128)',
		'ISOBUS.DDI.169': 'Stato di lavoro effettivo condensato (129-144)',
		'ISOBUS.DDI.17': 'Spaziatura effettiva di tasso di applicazione',
		'ISOBUS.DDI.170': 'Stato di lavoro effettivo condensato (145-160)',
		'ISOBUS.DDI.171': 'Stato di lavoro effettivo condensato (161-176)',
		'ISOBUS.DDI.172': 'Stato di lavoro effettivo condensato (177-192)',
		'ISOBUS.DDI.173': 'Stato di lavoro effettivo condensato (193-208)',
		'ISOBUS.DDI.174': 'Stato di lavoro effettivo condensato (209-224)',
		'ISOBUS.DDI.175': 'Stato di lavoro effettivo condensato (225-240)',
		'ISOBUS.DDI.176': 'Stato di lavoro effettivo condensato (241-256)',
		'ISOBUS.DDI.177': 'Lunghezza effettiva del taglio',
		'ISOBUS.DDI.178': 'Tipo di elemento Istanza',
		'ISOBUS.DDI.179': 'Pratica culturale attuale',
		'ISOBUS.DDI.18': 'Spaziatura predefinita di tasso di applicazione',
		'ISOBUS.DDI.180': 'Distanza tra il punto di riferimento del dispositivo (DRP) e la terra',
		'ISOBUS.DDI.181': 'Massa secca per area di resa',
		'ISOBUS.DDI.182': 'Massa secca per tempo di resa',
		'ISOBUS.DDI.183': 'Resa en massa secca totale',
		'ISOBUS.DDI.184': 'Umidità di riferimento per la massa secca',
		'ISOBUS.DDI.185': 'Massa di semi di cotone per area di produzione',
		'ISOBUS.DDI.186': 'Massa di lanugine di cotone per area di resa',
		'ISOBUS.DDI.187': 'Massa di semi di cotone per tempo di resa',
		'ISOBUS.DDI.188': 'Massa di lanugine di cotone per tempo di lavorazione',
		'ISOBUS.DDI.189': 'Resa in massa del cotone da seme totale',
		'ISOBUS.DDI.19': 'Spaziatura minima di tasso di applicazione',
		'ISOBUS.DDI.190': 'Resa in massa della lanugine di cotone totale',
		'ISOBUS.DDI.191': 'Percentuale di svolta della lanugine',
		'ISOBUS.DDI.192': 'Temperatura ambiente',
		'ISOBUS.DDI.193': 'Valore nominale di pressione del prodotto',
		'ISOBUS.DDI.194': 'Pressione effettiva del prodotto',
		'ISOBUS.DDI.195': 'Pressione minima del prodotto',
		'ISOBUS.DDI.196': 'Pressione massima del prodotto',
		'ISOBUS.DDI.197': 'Valore nominale di pressione di uscita della pompa',
		'ISOBUS.DDI.198': 'Pressione di uscita effettiva della pompa',
		'ISOBUS.DDI.199': 'Pressione minima di uscita della pompa',
		'ISOBUS.DDI.2': 'Volume effettivo per area di tasso di applicazione',
		'ISOBUS.DDI.20': 'Spaziatura massima di tasso di applicazione',
		'ISOBUS.DDI.200': 'Pressione massima di uscita della pompa',
		'ISOBUS.DDI.201': 'Valore nominale della pressione di agitazione del serbatoio',
		'ISOBUS.DDI.202': 'Pressione effettiva di agitazione del serbatoio',
		'ISOBUS.DDI.203': 'Pressione minima di agitazione del serbatoio',
		'ISOBUS.DDI.204': 'Pressione massima di agitazione del serbatoio',
		'ISOBUS.DDI.205': 'Tempo di accensione del SC',
		'ISOBUS.DDI.206': 'Tempo di spegnimento del SC',
		'ISOBUS.DDI.207': 'Velocità del vento',
		'ISOBUS.DDI.208': 'Direzione del vento',
		'ISOBUS.DDI.209': 'Umidità relativa',
		'ISOBUS.DDI.21': 'Valore nominale: Volume per Volume di Tasso di Applicazione ',
		'ISOBUS.DDI.210': 'Condizioni del cielo',
		'ISOBUS.DDI.211': 'Ultima balla fiocchi per balla',
		'ISOBUS.DDI.212': 'Umidità media dell\'ultima balla',
		'ISOBUS.DDI.213': 'Ultima balla media dei colpi per fiocco',
		'ISOBUS.DDI.214': 'Conteggio totale delle balle',
		'ISOBUS.DDI.215': 'Ore di lavoro totali',
		'ISOBUS.DDI.216': 'Pressione idraulica effettiva della balla',
		'ISOBUS.DDI.217': 'Ultima balla pressione idraulica media',
		'ISOBUS.DDI.218': 'Valore nominale di compressione della balla carico dello stantuffo',
		'ISOBUS.DDI.219': 'Carico effettivo del pistone di compressione della balla',
		'ISOBUS.DDI.22': 'Volume effettivo per volume di tasso di applicazione',
		'ISOBUS.DDI.220': 'Ultima balla carico medio di compressione dello stantuffo',
		'ISOBUS.DDI.221': 'Applicazione del conservante all\'ultima balla',
		'ISOBUS.DDI.222': 'Numero di etichetta dell\'ultima balla',
		'ISOBUS.DDI.223': 'Ultima massa di balle',
		'ISOBUS.DDI.224': 'Delta T ',
		'ISOBUS.DDI.225': 'Valore nominale della lunghezza di lavoro',
		'ISOBUS.DDI.226': 'Lunghezza effettiva di lavoro',
		'ISOBUS.DDI.227': 'Lunghezza minima di lavoro',
		'ISOBUS.DDI.228': 'Lunghezza massima di lavoro',
		'ISOBUS.DDI.229': 'Peso netto effettivo',
		'ISOBUS.DDI.23': 'Volume predefinito per volume di tasso di applicazione',
		'ISOBUS.DDI.230': 'Stato del peso netto',
		'ISOBUS.DDI.231': 'Stato del valore nominale del peso',
		'ISOBUS.DDI.232': 'Peso lordo effettivo',
		'ISOBUS.DDI.233': 'Stato del peso lordo',
		'ISOBUS.DDI.234': 'Peso lordo minimo',
		'ISOBUS.DDI.235': 'Peso lordo massimo',
		'ISOBUS.DDI.236': 'Impegno della trebbiatrice tempo totale',
		'ISOBUS.DDI.237': 'Stato dell\'altezza di lavoro effettiva della testata',
		'ISOBUS.DDI.238': 'Stato della velocità di rotazione effettiva della testata',
		'ISOBUS.DDI.239': 'Stato di mantenimento del rendimento',
		'ISOBUS.DDI.24': 'Volume minimo per volume di tasso di applicazione',
		'ISOBUS.DDI.240': 'Stato effettivo del sistema di (non) caricamento',
		'ISOBUS.DDI.241': 'Temperatura delle colture',
		'ISOBUS.DDI.242': 'Valore nominale della distanza dal setaccio',
		'ISOBUS.DDI.243': 'Distanza effettiva dal setaccio',
		'ISOBUS.DDI.244': 'Distanza minima dal setaccio',
		'ISOBUS.DDI.245': 'Distanza massima dal setaccio',
		'ISOBUS.DDI.246': 'Valore nominale delle spazio per il Chaffer',
		'ISOBUS.DDI.247': 'Spazio effettivo di Chaffer',
		'ISOBUS.DDI.248': 'Distanza minima dal Chaffer',
		'ISOBUS.DDI.249': 'Distanza massima dal Chaffer',
		'ISOBUS.DDI.25': 'Volume massimo per volume di tasso di applicazione',
		'ISOBUS.DDI.250': 'Distanza dal concavo del punto di regolazione',
		'ISOBUS.DDI.251': 'Gioco effettivo del concavo',
		'ISOBUS.DDI.252': 'Gioco minimo del concavo',
		'ISOBUS.DDI.253': 'Gioco massimo del concavo',
		'ISOBUS.DDI.254': 'Separazione del valore nominale della velocità di rotazione del ventilatore',
		'ISOBUS.DDI.255': 'Separazione effettiva della velocità di rotazione del ventilatore',
		'ISOBUS.DDI.256': 'Separazione minima della velocità di rotazione del ventilatore',
		'ISOBUS.DDI.257': 'Separazione massima della velocità di rotazione del ventilatore',
		'ISOBUS.DDI.258': 'Temperatura dell\'olio idraulico',
		'ISOBUS.DDI.259': 'Ritardo di rendimento di tempo ignorato',
		'ISOBUS.DDI.26': 'Valore nominale: Massa Per Massa di Tasso di applicazione',
		'ISOBUS.DDI.260': 'Rendimento en tempo di attesa',
		'ISOBUS.DDI.261': 'Rendimento medio di massa per tempo',
		'ISOBUS.DDI.262': 'Umidità media del raccolto',
		'ISOBUS.DDI.263': 'Resa media della massa per area',
		'ISOBUS.DDI.264': 'Perno del connettore X-Offset',
		'ISOBUS.DDI.265': 'Area rimanente',
		'ISOBUS.DDI.266': 'Applicazione totale della massa totale',
		'ISOBUS.DDI.267': 'Totale applicazione del conteggio totale',
		'ISOBUS.DDI.268': 'Rendimento totale en volume totale',
		'ISOBUS.DDI.269': 'Resa totale della massa totale',
		'ISOBUS.DDI.27': 'Massa effettiva per massa di tasso di applicazione',
		'ISOBUS.DDI.270': 'Rendimento totale del conteggio totale',
		'ISOBUS.DDI.271': 'Area totale',
		'ISOBUS.DDI.272': 'Distanza totale effettiva',
		'ISOBUS.DDI.273': 'Distanza totale inefficace ',
		'ISOBUS.DDI.274': 'Tempo totale effettivo',
		'ISOBUS.DDI.275': 'Tempo Totale inefficace ',
		'ISOBUS.DDI.276': 'Consumo totale di carburante',
		'ISOBUS.DDI.277': 'Consumo medio totale di carburante per tempo',
		'ISOBUS.DDI.278': 'Consumo medio totale di carburante per area',
		'ISOBUS.DDI.279': 'Resa totale della massa secca totale',
		'ISOBUS.DDI.28': 'Massa predefinita per massa di tasso di applicazione',
		'ISOBUS.DDI.280': 'Resa totale della massa di cotone da seme',
		'ISOBUS.DDI.281': 'Resa totale della massa cotoniera totale',
		'ISOBUS.DDI.282': 'Totale impegno di trebbiatura di tempo totale',
		'ISOBUS.DDI.283': 'Conteggio totale del pretagliato',
		'ISOBUS.DDI.284': 'Conteggio totale non tagliato',
		'ISOBUS.DDI.285': 'Totale pretagliato di conteggio totale',
		'ISOBUS.DDI.286': 'Totale non tagliato conteggio ',
		'ISOBUS.DDI.287': 'Valore nominale in modalità di prescrizione',
		'ISOBUS.DDI.288': 'Modalità di prescrizione effettiva',
		'ISOBUS.DDI.289': 'Valore nominale dello stato di lavoro',
		'ISOBUS.DDI.29': 'Massa minima per massa di tasso di applicazione',
		'ISOBUS.DDI.290': 'Setpoint stato di lavoro condensato (1-16) ',
		'ISOBUS.DDI.291': 'Setpoint stato di lavoro condensato (17-32) ',
		'ISOBUS.DDI.292': 'Setpoint stato di lavoro condensato (33-48) ',
		'ISOBUS.DDI.293': 'Setpoint stato di lavoro condensato (49-64) ',
		'ISOBUS.DDI.294': 'Setpoint stato di lavoro condensato (65-80) ',
		'ISOBUS.DDI.295': 'Setpoint stato di lavoro condensato (81-96) ',
		'ISOBUS.DDI.296': 'Setpoint stato di lavoro condensato (97-112) ',
		'ISOBUS.DDI.297': 'Setpoint stato di lavoro condensato (113-128) ',
		'ISOBUS.DDI.298': 'Setpoint stato di lavoro condensato (129-144) ',
		'ISOBUS.DDI.299': 'Setpoint stato di lavoro condensato (145-160) ',
		'ISOBUS.DDI.3': 'Volume predefinito per superficie di tasso di applicazione',
		'ISOBUS.DDI.30': 'Massa massima per dose di applicazione',
		'ISOBUS.DDI.300': 'Setpoint stato di lavoro condensato (161-176) ',
		'ISOBUS.DDI.301': 'Setpoint stato di lavoro condensato (177-192) ',
		'ISOBUS.DDI.302': 'Setpoint stato di lavoro condensato (193-208) ',
		'ISOBUS.DDI.303': 'Setpoint stato di lavoro condensato (209-224) ',
		'ISOBUS.DDI.304': 'Setpoint stato di lavoro condensato (225-240) ',
		'ISOBUS.DDI.305': 'Setpoint stato di lavoro condensato (241-256) ',
		'ISOBUS.DDI.306': 'Punto di rotazione vero X-Offset',
		'ISOBUS.DDI.307': 'Punto di rotazione vero Y-Offset',
		'ISOBUS.DDI.308': 'Percentuale effettiva di applicazione',
		'ISOBUS.DDI.309': 'Percentuale minima di applicazione',
		'ISOBUS.DDI.31': 'Valore nominale: Volume per Massa di Tasso di Applicazione',
		'ISOBUS.DDI.310': 'Percentuale massima di applicazione',
		'ISOBUS.DDI.311': 'Potenziale di rendimento relativo',
		'ISOBUS.DDI.312': 'Potenziale di rendimento relativo minimo',
		'ISOBUS.DDI.313': 'Potenziale di rendimento relativo massimo',
		'ISOBUS.DDI.314': 'Percentuale effettiva di sostanza secca del raccolto',
		'ISOBUS.DDI.315': 'Percentuale media di sostanza secca del raccolto',
		'ISOBUS.DDI.316': 'Consumo totale effettivo di carburante',
		'ISOBUS.DDI.317': 'Consumo totale di carburante inefficace',
		'ISOBUS.DDI.318': 'Consumo totale effettivo di carburante diesel',
		'ISOBUS.DDI.319': 'Consumo totale di carburante diesel inefficace',
		'ISOBUS.DDI.32': 'Volume effettivo per dose di applicazione di massa',
		'ISOBUS.DDI.320': 'Ultimo peso caricato',
		'ISOBUS.DDI.321': 'Peso dell\'ultimo scarico',
		'ISOBUS.DDI.322': 'Numero di identificazione del carico',
		'ISOBUS.DDI.323': 'Numero di identificazione dello scarico',
		'ISOBUS.DDI.324': 'Tempo totale di innesto della mannaia',
		'ISOBUS.DDI.325': 'Applicazione totale di volume totale',
		'ISOBUS.DDI.326': 'Valore nominale della velocità della testata',
		'ISOBUS.DDI.327': 'Velocità effettiva della testata',
		'ISOBUS.DDI.328': 'Velocità minima della testata',
		'ISOBUS.DDI.329': 'Velocità massima della testata',
		'ISOBUS.DDI.33': 'Volume predefinito per dose di applicazione di massa',
		'ISOBUS.DDI.330': 'Valore nominale della velocità del tamburo di taglio',
		'ISOBUS.DDI.331': 'Velocità effettiva del tamburo di taglio',
		'ISOBUS.DDI.332': 'Velocità minima del tamburo di taglio',
		'ISOBUS.DDI.333': 'Velocità massima del tamburo di taglio',
		'ISOBUS.DDI.334': 'Ore di funzionamento dall\'ultima affilatura',
		'ISOBUS.DDI.335': 'Ore della PDF anteriore',
		'ISOBUS.DDI.336': 'Ore della PDF posteriore',
		'ISOBUS.DDI.337': 'Totale ore di PDF anteriore',
		'ISOBUS.DDI.338': 'Ore totali della PDF posteriore',
		'ISOBUS.DDI.339': 'Tempo di caricamento totale effettivo',
		'ISOBUS.DDI.34': 'Volume minimo per dose di applicazione di massa',
		'ISOBUS.DDI.340': 'Tempo effettivo di scarico totale',
		'ISOBUS.DDI.341': 'Valore nominale delle spazio per i chicchi di cereali',
		'ISOBUS.DDI.342': 'Spazio effettivo per i chicchi di cereali',
		'ISOBUS.DDI.343': 'Spazio minimo per i chicchi di cereali',
		'ISOBUS.DDI.344': 'Spazio massimo per i chicchi di cereali',
		'ISOBUS.DDI.345': 'Valore nominale della larghezza di andanatura',
		'ISOBUS.DDI.346': 'Larghezza effettiva dell\'andana',
		'ISOBUS.DDI.347': 'Larghezza minima dell\'andana',
		'ISOBUS.DDI.348': 'Larghezza massima dell\'andana',
		'ISOBUS.DDI.349': 'Riduzione della deriva dell\'ugello',
		'ISOBUS.DDI.35': 'Volume massimo per dose di applicazione in massa',
		'ISOBUS.DDI.350': 'Funzione o tecnica operativa',
		'ISOBUS.DDI.351': 'Applicazione del volume totale',
		'ISOBUS.DDI.352': 'Applicazione di massa totale',
		'ISOBUS.DDI.353': 'Applicazione totale di azoto',
		'ISOBUS.DDI.354': 'Applicazione totale di ammonio',
		'ISOBUS.DDI.355': 'Applicazione totale di fosforo',
		'ISOBUS.DDI.356': 'Applicazione totale di potassio',
		'ISOBUS.DDI.357': 'Applicazione totale di materia secca',
		'ISOBUS.DDI.358': 'Resa secca media di massa per tempo',
		'ISOBUS.DDI.359': 'Resa secca media di massa per area',
		'ISOBUS.DDI.36': 'Valore nominale: Volume per Tempo di Tasso di Applicazione',
		'ISOBUS.DDI.360': 'Dimensione dell\'ultima balla',
		'ISOBUS.DDI.361': 'Densità dell\'ultima balla',
		'ISOBUS.DDI.362': 'Lunghezza totale della balla',
		'ISOBUS.DDI.363': 'Massa secca dell\'ultima balla',
		'ISOBUS.DDI.364': 'Dimensione effettiva del fiocco',
		'ISOBUS.DDI.365': 'Valore nominale pressione di deportanza',
		'ISOBUS.DDI.366': 'Pressione effettiva di deportanza',
		'ISOBUS.DDI.367': 'Sezione condensata: Stato di esclusione (1-16) ',
		'ISOBUS.DDI.368': 'Sezione condensata: Stato di esclusione (17-32) ',
		'ISOBUS.DDI.369': 'Sezione condensata: Stato di esclusione (33-48) ',
		'ISOBUS.DDI.37': 'Volume effettivo per volta di tasso di applicazione',
		'ISOBUS.DDI.370': 'Sezione condensata: Stato di esclusione (49-64) ',
		'ISOBUS.DDI.371': 'Sezione condensata: Stato di esclusione (65-80) ',
		'ISOBUS.DDI.372': 'Sezione condensata: Stato di esclusione (81-96) ',
		'ISOBUS.DDI.373': 'Sezione condensata: Stato di esclusione (97-112) ',
		'ISOBUS.DDI.374': 'Sezione condensata: Stato di esclusione (113-128) ',
		'ISOBUS.DDI.375': 'Sezione condensata: Stato di esclusione (129-144) ',
		'ISOBUS.DDI.376': 'Sezione condensata: Stato di esclusione (145-160) ',
		'ISOBUS.DDI.377': 'Sezione condensata: Stato di esclusione (161-176) ',
		'ISOBUS.DDI.378': 'Sezione condensata: Stato di esclusione (177-192) ',
		'ISOBUS.DDI.379': 'Sezione condensata: Stato di esclusione (193-208) ',
		'ISOBUS.DDI.38': 'Volume predefinito per volta di tasso di applicazione',
		'ISOBUS.DDI.380': 'Sezione condensata: Stato di esclusione (209-224) ',
		'ISOBUS.DDI.381': 'Sezione condensata: Stato di esclusione (225-240) ',
		'ISOBUS.DDI.382': 'Sezione condensata: Stato di esclusione (241-256) ',
		'ISOBUS.DDI.383': 'Direzione del vento apparente',
		'ISOBUS.DDI.384': 'Velocità del vento apparente',
		'ISOBUS.DDI.385': 'Pressione atmosferica MSL',
		'ISOBUS.DDI.386': 'Pressione atmosferica effettiva',
		'ISOBUS.DDI.387': 'Giri totali in giri frazionari',
		'ISOBUS.DDI.388': 'Rivoluzioni totali in rivoluzioni complete',
		'ISOBUS.DDI.389': 'Valore nominale I giri specificati come conteggio per tempo',
		'ISOBUS.DDI.39': 'Volume minimo per volta di tasso di applicazione',
		'ISOBUS.DDI.390': 'Giri effettivi per tempo',
		'ISOBUS.DDI.391': 'Rivoluzioni predefinite per tempo',
		'ISOBUS.DDI.392': 'Giri minimi per tempo',
		'ISOBUS.DDI.393': 'Giri massimi per tempo',
		'ISOBUS.DDI.394': 'Contenuto effettivo del serbatoio del carburante',
		'ISOBUS.DDI.395': 'Contenuto effettivo del serbatoio dei gas di scarico carburanti',
		'ISOBUS.DDI.396': 'Velocità nominale',
		'ISOBUS.DDI.397': 'Velocità effettiva',
		'ISOBUS.DDI.398': 'Velocità minima',
		'ISOBUS.DDI.399': 'Velocità massima',
		'ISOBUS.DDI.4': 'Volume minimo per area di tasso di applicazione',
		'ISOBUS.DDI.40': 'Volume massimo per volta di tasso di applicazione',
		'ISOBUS.DDI.400': 'Fonte di velocità',
		'ISOBUS.DDI.401': 'Applicazione effettiva di azoto',
		'ISOBUS.DDI.402': 'Applicazione effettiva di ammonio',
		'ISOBUS.DDI.403': 'Applicazione effettiva di fosforo',
		'ISOBUS.DDI.404': 'Applicazione effettiva del potassio',
		'ISOBUS.DDI.405': 'Applicazione effettiva della sostanza secca',
		'ISOBUS.DDI.406': 'Contenuto proteico effettivo',
		'ISOBUS.DDI.407': 'Contenuto medio di proteine',
		'ISOBUS.DDI.408': 'Contaminazione media delle colture',
		'ISOBUS.DDI.409': 'Consumo totale di carburante diesel',
		'ISOBUS.DDI.41': 'Valore nominale: Massa Per Tempo di Tasso di applicazione',
		'ISOBUS.DDI.410': 'Consumo di carburante diesel per tempo',
		'ISOBUS.DDI.411': 'Consumo di carburante diesel per area',
		'ISOBUS.DDI.412': 'Consumo totale di gas di scarico diesel',
		'ISOBUS.DDI.413': 'Consumo medio totale di gasolio per tempo',
		'ISOBUS.DDI.414': 'Consumo medio totale di fluidi per gas di scarico diesel per area',
		'ISOBUS.DDI.415': 'Percentuale reale di semi singolarizzati',
		'ISOBUS.DDI.416': 'Percentuale media di semi singolarizzati',
		'ISOBUS.DDI.417': 'Percentuale effettiva di salto del seme',
		'ISOBUS.DDI.418': 'Percentuale media di salto del seme',
		'ISOBUS.DDI.419': 'Percentuale multipla del seme effettivo',
		'ISOBUS.DDI.42': 'Massa effettiva per volta di tasso di applicazione',
		'ISOBUS.DDI.420': 'Percentuale media di semi multipli',
		'ISOBUS.DDI.421': 'Deviazione della spaziatura effettiva dei semi',
		'ISOBUS.DDI.422': 'Deviazione media della distanza tra i semi',
		'ISOBUS.DDI.423': 'Coefficiente medio di variazione della spaziatura dei semi percentuale',
		'ISOBUS.DDI.424': 'Coefficiente medio di variazione della spaziatura dei semi percentuale',
		'ISOBUS.DDI.425': 'Valore nominale della deviazione massima consentita per la spaziatura dei semi',
		'ISOBUS.DDI.426': 'Valore nominale della deportanza come forza',
		'ISOBUS.DDI.427': 'Forza di deportanza effettiva come forza',
		'ISOBUS.DDI.428': 'Massa totale caricata',
		'ISOBUS.DDI.429': 'Massa totale non caricata',
		'ISOBUS.DDI.43': 'Tasso di applicazione predefinito della massa per volta',
		'ISOBUS.DDI.430': 'Massa totale caricata ',
		'ISOBUS.DDI.431': 'Massa totale a vuoto',
		'ISOBUS.DDI.432': 'Tasso di applicazione nominale dell\'azoto',
		'ISOBUS.DDI.433': 'Tasso effettivo di applicazione dell\'azoto',
		'ISOBUS.DDI.434': 'Tasso minimo di applicazione dell\'azoto',
		'ISOBUS.DDI.435': 'Tasso massimo di applicazione dell\'azoto',
		'ISOBUS.DDI.436': 'Tasso di applicazione nominale di ammonio',
		'ISOBUS.DDI.437': 'Tasso di applicazione effettivo dell\'ammonio',
		'ISOBUS.DDI.438': 'Tasso minimo di applicazione dell\'ammonio',
		'ISOBUS.DDI.439': 'Tasso massimo di applicazione dell\'ammonio',
		'ISOBUS.DDI.44': 'Massa minima per volta di tasso di applicazione',
		'ISOBUS.DDI.440': 'Tasso di applicazione nominale di fosforo',
		'ISOBUS.DDI.441': 'Tasso di applicazione effettivo di fosforo',
		'ISOBUS.DDI.442': 'Tassa di applicazione minima di fosforo',
		'ISOBUS.DDI.443': 'Tassa di applicazione massima di fosforo',
		'ISOBUS.DDI.444': 'Tasso di applicazione nominale del potassio',
		'ISOBUS.DDI.445': 'Tasso di applicazione effettivo del potassio',
		'ISOBUS.DDI.446': 'Tasso minimo di applicazione del potassio',
		'ISOBUS.DDI.447': 'Tasso massimo di applicazione del potassio',
		'ISOBUS.DDI.448': 'Tasso di applicazione nominale della sostanza secca',
		'ISOBUS.DDI.449': 'Tasso di applicazione effettivo della sostanza secca',
		'ISOBUS.DDI.45': 'Massa massima per volta di tasso di applicazione',
		'ISOBUS.DDI.450': 'Tasso minimo di applicazione della sostanza secca',
		'ISOBUS.DDI.451': 'Tasso massimo di applicazione della sostanza secca',
		'ISOBUS.DDI.452': 'Volume totale caricato',
		'ISOBUS.DDI.453': 'Volume totale a vuoto',
		'ISOBUS.DDI.454': 'Volume totale caricato ',
		'ISOBUS.DDI.455': 'Volume totale a vuoto',
		'ISOBUS.DDI.456': 'Ultimo volume caricato',
		'ISOBUS.DDI.457': 'Ultimo volume scaricato',
		'ISOBUS.DDI.458': 'Conteggio totale del carico',
		'ISOBUS.DDI.459': 'Conteggio totale non caricato',
		'ISOBUS.DDI.46': 'Valore nominale del conteggio per tempo di velocità di applicazione',
		'ISOBUS.DDI.460': 'Totale caricato del conteggio totale',
		'ISOBUS.DDI.461': 'Totale scaricato del conteggio totale',
		'ISOBUS.DDI.462': 'Ultimo conteggio caricato',
		'ISOBUS.DDI.463': 'Ultimo conteggio di scarico',
		'ISOBUS.DDI.464': 'Contatore di trasporto',
		'ISOBUS.DDI.465': 'Contatore totale dei trasporti',
		'ISOBUS.DDI.466': 'Angolo effettivo del connettore relativo',
		'ISOBUS.DDI.467': 'Contenuto percentuale effettivo',
		'ISOBUS.DDI.468': 'Terreno Neve/Condensa ghiacciata',
		'ISOBUS.DDI.469': 'Condzione idrica stimata del suolo',
		'ISOBUS.DDI.47': 'Conteggio effettivo per volta di tasso di applicazione',
		'ISOBUS.DDI.470': 'Compattazione del suolo',
		'ISOBUS.DDI.472': 'Valore nominale della lunghezza di taglio',
		'ISOBUS.DDI.473': 'Lunghezza minima del taglio',
		'ISOBUS.DDI.474': 'Lunghezza massima del taglio',
		'ISOBUS.DDI.475': 'Valore nominale della pressione idraulica della balla',
		'ISOBUS.DDI.476': 'Pressione idraulica minima della balla',
		'ISOBUS.DDI.477': 'Pressione idraulica massima della balla',
		'ISOBUS.DDI.478': 'Valore nominale della dimensione del fiocco',
		'ISOBUS.DDI.479': 'Dimensione minima del fiocco',
		'ISOBUS.DDI.48': 'Conteggio predefinito per volta di velocità di applicazione',
		'ISOBUS.DDI.480': 'Dimensione massima del fiocco',
		'ISOBUS.DDI.481': 'Valore nominale di numero di sottoballe',
		'ISOBUS.DDI.482': 'Ultimo numero di balla sottoballe',
		'ISOBUS.DDI.483': 'Valore nominale della velocità del motore',
		'ISOBUS.DDI.484': 'Velocità effettiva del motore',
		'ISOBUS.DDI.485': 'Velocità minima del motore',
		'ISOBUS.DDI.486': 'Velocità massima del motore',
		'ISOBUS.DDI.488': 'Livello percentuale del serbatoio del liquido di scarico diesel',
		'ISOBUS.DDI.489': 'Contenuto massimo del carburante diesel di scarico diesel',
		'ISOBUS.DDI.49': 'Conteggio minimo per volta di tasso di applicazione',
		'ISOBUS.DDI.490': 'Contenuto massimo del serbatoio del carburante',
		'ISOBUS.DDI.491': 'Livello percentuale di carburante',
		'ISOBUS.DDI.492': 'Ore totali di funzionamento del motore',
		'ISOBUS.DDI.493': 'Ore totali di funzionamento del motore',
		'ISOBUS.DDI.494': 'ID partner ultimo evento (Byte 1-4)',
		'ISOBUS.DDI.495': 'ID partner ultimo evento (Byte 5-8) ',
		'ISOBUS.DDI.496': 'ID partner ultimo evento (Byte 9-12) ',
		'ISOBUS.DDI.497': 'ID partner ultimo evento (Byte 13-16) ',
		'ISOBUS.DDI.498': 'Ultimo evento Tipo di ID partner',
		'ISOBUS.DDI.499': 'Ultimo evento ID partner Codice ID produttore',
		'ISOBUS.DDI.5': 'Volume massimo per area di tasso di applicazione',
		'ISOBUS.DDI.50': 'Numero massimo di conteggi per volta di tasso di applicazione',
		'ISOBUS.DDI.500': 'Ultimo evento ID partner Classe dispositivo',
		'ISOBUS.DDI.501': 'Coppia motore nominale',
		'ISOBUS.DDI.502': 'Coppia effettiva del motore',
		'ISOBUS.DDI.503': 'Coppia minima del motore',
		'ISOBUS.DDI.504': 'Coppia massima del motore',
		'ISOBUS.DDI.505': 'Livello di controllo della linea tranviaria',
		'ISOBUS.DDI.506': 'Valore nominale di livello di regolazione della linea tranviaria',
		'ISOBUS.DDI.507': 'Numero di sequenza della linea tranviaria',
		'ISOBUS.DDI.508': 'ID univoco della riga di riferimento della guida A-B',
		'ISOBUS.DDI.509': 'Numero effettivo della traccia',
		'ISOBUS.DDI.51': 'Valore nominale della profondità di lavorazione del terreno',
		'ISOBUS.DDI.510': 'Numero di traccia a destra',
		'ISOBUS.DDI.511': 'Numero della traccia a sinistra',
		'ISOBUS.DDI.512': 'Larghezza dell\'andana della linea di guida',
		'ISOBUS.DDI.513': 'Deviazione della linea guida',
		'ISOBUS.DDI.514': 'Qualità GNSS',
		'ISOBUS.DDI.515': 'Stato di controllo della linea tranviaria',
		'ISOBUS.DDI.516': 'Tasso di sovradosaggio della tramina',
		'ISOBUS.DDI.517': 'Valore nominale di linea tranviaria di stato di lavoro condensato (1-16)',
		'ISOBUS.DDI.518': 'Stato effettivo del lavoro condensato della linea tranviaria (1-16)',
		'ISOBUS.DDI.519': ' Conteggio totale dell\'ultima balla',
		'ISOBUS.DDI.52': 'Profondità effettiva di lavorazione del suolo',
		'ISOBUS.DDI.520': 'Altezza effettiva della tettoia',
		'ISOBUS.DDI.521': 'Tipo di installazione GNSS',
		'ISOBUS.DDI.522': 'Conto totale delle balle di spago',
		'ISOBUS.DDI.523': 'Conteggio totale delle balle di rete',
		'ISOBUS.DDI.524': ' Conteggio totale di balle di spago totali ',
		'ISOBUS.DDI.525': 'Totale balle di rete in totale conteggio',
		'ISOBUS.DDI.526': 'Temperatura effettiva del liquido di raffreddamento',
		'ISOBUS.DDI.528': 'Capacità dell\'ultima balla',
		'ISOBUS.DDI.529': 'Valore nominale dell\'angolo della banda dei dischi per la lavorazione del terreno',
		'ISOBUS.DDI.53': 'Profondità di lavorazione predefinita',
		'ISOBUS.DDI.530': 'Angolo effettivo della banda del disco per la lavorazione del terreno',
		'ISOBUS.DDI.531': 'Conservante effettivo applicato per massa resa',
		'ISOBUS.DDI.532': 'Valore nominale del conservante applicato per massa resa ',
		'ISOBUS.DDI.533': 'Conservante applicato per default per massa resa',
		'ISOBUS.DDI.534': 'Conservante minimo applicato per massa resa',
		'ISOBUS.DDI.535': 'Conservante massimo applicato per massa resa',
		'ISOBUS.DDI.536': 'Totale conservante applicato',
		'ISOBUS.DDI.537': 'Conservante applicato a vita',
		'ISOBUS.DDI.538': 'Conservante medio applicato per massa resa',
		'ISOBUS.DDI.539': 'Volume effettivo del serbatoio del conservante',
		'ISOBUS.DDI.54': 'Profondità minima di lavorazione del terreno',
		'ISOBUS.DDI.540': 'Livello effettivo del serbatoio del conservante',
		'ISOBUS.DDI.541': 'Velocità effettiva della PDF',
		'ISOBUS.DDI.542': 'Setpoint Velocità della PDF',
		'ISOBUS.DDI.543': 'Velocità predefinita della PDF',
		'ISOBUS.DDI.544': 'Velocità minima della PDF',
		'ISOBUS.DDI.545': 'Velocità massima della PDF',
		'ISOBUS.DDI.546': 'Impegno totale di tritatura in tempo totale',
		'ISOBUS.DDI.547': 'Valore nominale di compressione della balla carico dello stantuffo',
		'ISOBUS.DDI.548': 'Carico effettivo del pistone di compressione della balla',
		'ISOBUS.DDI.549': 'Ultima balla carica media di compressione dello stantuffo',
		'ISOBUS.DDI.55': 'Profondità massima di lavorazione del terreno',
		'ISOBUS.DDI.550': 'Copertura del suolo',
		'ISOBUS.DDI.551': 'Coppia attuale della PDF',
		'ISOBUS.DDI.552': 'Valore nominale della coppia cardanica della PDF',
		'ISOBUS.DDI.553': 'Coppia della PDF predefinita',
		'ISOBUS.DDI.554': 'Coppia minima della PTO',
		'ISOBUS.DDI.555': 'Coppia massima della PTO',
		'ISOBUS.DDI.556': 'Condizioni meteorologiche attuali',
		'ISOBUS.DDI.557': 'Valore nominale della corrente elettrica',
		'ISOBUS.DDI.558': 'Corrente elettrica effettiva',
		'ISOBUS.DDI.559': 'Corrente elettrica minima',
		'ISOBUS.DDI.56': 'Valore nominale della profondità di semina',
		'ISOBUS.DDI.560': 'Corrente elettrica massima',
		'ISOBUS.DDI.561': 'Corrente elettrica predefinita',
		'ISOBUS.DDI.562': 'Tensione nominale',
		'ISOBUS.DDI.563': 'Tensione predefinita',
		'ISOBUS.DDI.564': 'Tensione effettiva',
		'ISOBUS.DDI.565': 'Tensione minima',
		'ISOBUS.DDI.566': 'Tensione massima',
		'ISOBUS.DDI.567': 'Resistenza elettrica effettiva',
		'ISOBUS.DDI.568': 'Valore nominale della potenza elettrica',
		'ISOBUS.DDI.569': 'Potenza elettrica effettiva',
		'ISOBUS.DDI.57': 'Profondità di semina effettiva',
		'ISOBUS.DDI.570': 'Potenza elettrica predefinita',
		'ISOBUS.DDI.571': 'Potenza elettrica massima',
		'ISOBUS.DDI.572': 'Potenza elettrica minima',
		'ISOBUS.DDI.573': 'Energia elettrica totale',
		'ISOBUS.DDI.574': 'Valore nominale di energia elettrica per area di tasso di applicazione',
		'ISOBUS.DDI.575': 'Energia elettrica effettiva per area di tasso di applicazione',
		'ISOBUS.DDI.576': 'Energia elettrica massima per area di tasso di applicazione',
		'ISOBUS.DDI.577': 'Energia elettrica minima per area di tasso di applicazione',
		'ISOBUS.DDI.578': 'Temperatura nominale',
		'ISOBUS.DDI.579': 'Temperatura effettiva',
		'ISOBUS.DDI.58': 'Profondità di semina predefinita',
		'ISOBUS.DDI.580': 'Temperatura minima',
		'ISOBUS.DDI.581': 'Temperatura massima',
		'ISOBUS.DDI.582': 'Temperatura predefinita',
		'ISOBUS.DDI.583': 'Frequenza nominale',
		'ISOBUS.DDI.584': 'Frequenza effettiva',
		'ISOBUS.DDI.585': 'Frequenza minima',
		'ISOBUS.DDI.586': 'Frequenza massima',
		'ISOBUS.DDI.587': 'Piogge precedenti',
		'ISOBUS.DDI.588': 'Valore nominale: Volume per Area di Tasso di Applicazione',
		'ISOBUS.DDI.589': 'Volume effettivo per area di tasso di applicazione',
		'ISOBUS.DDI.59': 'Profondità minima di semina',
		'ISOBUS.DDI.590': 'Volume minimo per area di tasso di applicazione',
		'ISOBUS.DDI.591': 'Volume massimo per area di tasso di applicazione',
		'ISOBUS.DDI.592': 'Volume predefinito per area di tasso di applicazione',
		'ISOBUS.DDI.593': 'Tipo di trazione',
		'ISOBUS.DDI.594': 'Tipo di sterzo',
		'ISOBUS.DDI.595': 'Modalità macchina',
		'ISOBUS.DDI.596': 'Stato di copertura dell\'area di carico',
		'ISOBUS.DDI.597': 'Distanza totale',
		'ISOBUS.DDI.598': 'Durata della distanza totale',
		'ISOBUS.DDI.599': 'Distanza totale del campo',
		'ISOBUS.DDI.6': 'Valore nominale: Massa Per Area di Tasso di applicazione',
		'ISOBUS.DDI.60': 'Profondità massima di semina',
		'ISOBUS.DDI.600': 'Durata di distanza totale del campo',
		'ISOBUS.DDI.601': 'Distanza totale della strada',
		'ISOBUS.DDI.602': 'Durata di distanza totale della strada',
		'ISOBUS.DDI.603': 'Stato effettivo del lavoro condensato della linea tranviaria (17-32) ',
		'ISOBUS.DDI.604': 'Stato effettivo del lavoro condensato della linea tranviaria (33-48) ',
		'ISOBUS.DDI.605': 'Stato effettivo del lavoro condensato della linea tranviaria (49-64) ',
		'ISOBUS.DDI.606': 'Stato effettivo del lavoro condensato della linea tranviaria (65-80) ',
		'ISOBUS.DDI.607': 'Stato effettivo del lavoro condensato della linea tranviaria (81-96) ',
		'ISOBUS.DDI.608': 'Stato effettivo del lavoro condensato della linea tranviaria (97-112) ',
		'ISOBUS.DDI.609': 'Stato effettivo del lavoro condensato della linea tranviaria (113-128) ',
		'ISOBUS.DDI.61': 'Altezza di lavoro nominale',
		'ISOBUS.DDI.610': 'Stato effettivo del lavoro condensato della linea tranviaria (129-144) ',
		'ISOBUS.DDI.611': 'Stato effettivo del lavoro condensato della linea tranviaria (145-160) ',
		'ISOBUS.DDI.612': 'Stato effettivo del lavoro condensato della linea tranviaria (161-176) ',
		'ISOBUS.DDI.613': 'Stato effettivo del lavoro condensato della linea tranviaria (177-192) ',
		'ISOBUS.DDI.614': 'Stato effettivo del lavoro condensato della linea tranviaria (193-208)  ',
		'ISOBUS.DDI.615': 'Stato effettivo del lavoro condensato della linea tranviaria (209-224) ',
		'ISOBUS.DDI.616': 'Stato effettivo del lavoro condensato della linea tranviaria (225-240) ',
		'ISOBUS.DDI.617': 'Stato effettivo del lavoro condensato della linea tranviaria (241-256) ',
		'ISOBUS.DDI.618': 'Valore nominale di linea tranviaria di stato di lavoro condensato (17-32) ',
		'ISOBUS.DDI.619': 'Valore nominale di linea tranviaria di stato di lavoro condensato (33-48) ',
		'ISOBUS.DDI.62': 'Altezza di lavoro effettiva',
		'ISOBUS.DDI.620': 'Valore nominale di linea tranviaria di stato di lavoro condensato (49-64) ',
		'ISOBUS.DDI.621': 'Valore nominale di linea tranviaria di stato di lavoro condensato (65-80) ',
		'ISOBUS.DDI.622': 'Valore nominale di linea tranviaria di stato di lavoro condensato (81-96) ',
		'ISOBUS.DDI.623': 'Valore nominale di linea tranviaria di stato di lavoro condensato (97-112) ',
		'ISOBUS.DDI.624': 'Valore nominale di linea tranviaria di stato di lavoro condensato (113-128) ',
		'ISOBUS.DDI.625': 'Valore nominale di linea tranviaria di stato di lavoro condensato (129-144) ',
		'ISOBUS.DDI.626': 'Valore nominale di linea tranviaria di stato di lavoro condensato (145-160) ',
		'ISOBUS.DDI.627': 'Valore nominale di linea tranviaria di stato di lavoro condensato (161-176) ',
		'ISOBUS.DDI.628': 'Valore nominale di linea tranviaria di stato di lavoro condensato (177-192) ',
		'ISOBUS.DDI.629': 'Valore nominale di linea tranviaria di stato di lavoro condensato (193-208) ',
		'ISOBUS.DDI.63': 'Altezza di lavoro predefinita',
		'ISOBUS.DDI.630': 'Valore nominale di linea tranviaria di stato di lavoro condensato (209-224) ',
		'ISOBUS.DDI.631': 'Valore nominale di linea tranviaria di stato di lavoro condensato (225-240) ',
		'ISOBUS.DDI.632': 'Valore nominale di linea tranviaria di stato di lavoro condensato (241-256) ',
		'ISOBUS.DDI.634': 'Volume effettivo per distanza di tasso di applicazione',
		'ISOBUS.DDI.635': 'Volume predefinito per distanza di tasso di applicazione',
		'ISOBUS.DDI.636': 'Volume minimo per distanza di tasso di applicazione',
		'ISOBUS.DDI.637': 'Volume massimo per distanza di tasso di applicazione',
		'ISOBUS.DDI.638': 'Pressione nominale degli pneumatici',
		'ISOBUS.DDI.639': 'Pressione effettiva degli pneumatici',
		'ISOBUS.DDI.64': 'Altezza minima di lavoro',
		'ISOBUS.DDI.640': 'Pressione degli pneumatici predefinita',
		'ISOBUS.DDI.641': 'Pressione minima degli pneumatici',
		'ISOBUS.DDI.642': 'Pressione massima degli pneumatici',
		'ISOBUS.DDI.643': 'Temperatura effettiva del pneumatico',
		'ISOBUS.DDI.65': 'Altezza massima di lavoro',
		'ISOBUS.DDI.66': 'Valore nominale di larghezza di lavoro',
		'ISOBUS.DDI.67': 'Larghezza di lavoro effettiva',
		'ISOBUS.DDI.68': 'Larghezza di lavoro predefinita',
		'ISOBUS.DDI.69': 'Larghezza minima di lavoro',
		'ISOBUS.DDI.7': 'Massa effettiva per area di tasso di applicazione',
		'ISOBUS.DDI.70': 'Larghezza massima di lavoro',
		'ISOBUS.DDI.71': 'Valore nominale: Volume Contenuto',
		'ISOBUS.DDI.72': 'Contenuto effettivo del volume',
		'ISOBUS.DDI.73': 'Volume massimo contenuto',
		'ISOBUS.DDI.74': 'Valore nominale: Contenuto di massa',
		'ISOBUS.DDI.75': 'Contenuto di massa effettivo',
		'ISOBUS.DDI.76': 'Contenuto di massa massimo',
		'ISOBUS.DDI.77': 'Contenuto del conteggio del setpoint',
		'ISOBUS.DDI.78': 'Contenuto effettivo del conteggio',
		'ISOBUS.DDI.79': 'Contenuto massimo del conteggio',
		'ISOBUS.DDI.8': 'Massa per superficie predefinita di tasso di applicazione',
		'ISOBUS.DDI.80': 'Applicazione volume totale',
		'ISOBUS.DDI.81': 'Applicazione massa totale',
		'ISOBUS.DDI.82': 'Applicazione conteggio totale',
		'ISOBUS.DDI.83': 'Volume per area rendimento',
		'ISOBUS.DDI.84': 'Massa per area rendimento',
		'ISOBUS.DDI.85': 'Conteggio per area rendimento',
		'ISOBUS.DDI.86': 'Volume per tempo rendimento',
		'ISOBUS.DDI.87': 'Massa per tempo rendimento',
		'ISOBUS.DDI.88': 'Conteggio per tempo rendimento',
		'ISOBUS.DDI.89': 'Resa volumetrica totale',
		'ISOBUS.DDI.9': 'Massa minima per area di tasso di applicazione',
		'ISOBUS.DDI.90': 'Rendimento di massa totale',
		'ISOBUS.DDI.91': 'Prestazioni del conteggio totale',
		'ISOBUS.DDI.92': 'Volume per area di perdita del raccolto',
		'ISOBUS.DDI.93': 'Massa per area di perdita del raccolto',
		'ISOBUS.DDI.94': 'Conteggio per area di perdita delle colture',
		'ISOBUS.DDI.95': 'Volume per tempo di perdita di raccolto',
		'ISOBUS.DDI.96': 'Massa per tempo di perdita di raccolto',
		'ISOBUS.DDI.97': 'Conteggio per volta di perdita di raccolto',
		'ISOBUS.DDI.98': 'Percentuale di perdita del raccolto',
		'ISOBUS.DDI.99': 'Umidità delle colture',
		'ISOBUS.DEVICE_CLASS.0': 'Non specificato',
		'ISOBUS.DEVICE_CLASS.1': 'Trattore',
		'ISOBUS.DEVICE_CLASS.10': 'Irrigazione',
		'ISOBUS.DEVICE_CLASS.11': 'Trasporto/Trailer',
		'ISOBUS.DEVICE_CLASS.12': 'Operazioni di cantiere',
		'ISOBUS.DEVICE_CLASS.13': 'Dispositivi ausiliari alimentati',
		'ISOBUS.DEVICE_CLASS.14': 'Colture speciali',
		'ISOBUS.DEVICE_CLASS.15': 'Lavoro di terra',
		'ISOBUS.DEVICE_CLASS.16': 'Skidder',
		'ISOBUS.DEVICE_CLASS.17': 'Sistemi di sensori',
		'ISOBUS.DEVICE_CLASS.18': ' - ',
		'ISOBUS.DEVICE_CLASS.19': 'Raccoglitori di legname',
		'ISOBUS.DEVICE_CLASS.2': 'Lavorazione del terreno',
		'ISOBUS.DEVICE_CLASS.20': 'Spedizionieri',
		'ISOBUS.DEVICE_CLASS.21': 'Caricatori di legname',
		'ISOBUS.DEVICE_CLASS.22': 'Macchine per la lavorazione del legno',
		'ISOBUS.DEVICE_CLASS.23': 'Trinciatrici',
		'ISOBUS.DEVICE_CLASS.24': 'Veicoli utilitari',
		'ISOBUS.DEVICE_CLASS.25': 'Applicatori di liquami e concimi',
		'ISOBUS.DEVICE_CLASS.26': 'Alimentatori/miscelatori',
		'ISOBUS.DEVICE_CLASS.27': 'Diserbanti',
		'ISOBUS.DEVICE_CLASS.3': 'Dissodamento secondario',
		'ISOBUS.DEVICE_CLASS.4': 'Fioriere/seminatrici',
		'ISOBUS.DEVICE_CLASS.5': 'Fertilizzanti',
		'ISOBUS.DEVICE_CLASS.6': 'Spruzzatori',
		'ISOBUS.DEVICE_CLASS.7': 'Mietitori',
		'ISOBUS.DEVICE_CLASS.8': 'Raccoglitori di radici',
		'ISOBUS.DEVICE_CLASS.9': 'Foraggio',
		'JOB.ARCHIVE.QUESTION': 'Volete davvero archiviare questo lavoro?',
		'JOB.ARCHIVE.SUCCESS': 'Il lavoro verrà archiviato',
		'JOB.CAN_NOT_BE_DISPLAYED_COMPLETELY': 'Il lavoro non può essere visualizzato completamente. Tutte le informazioni sopra riportate potrebbero essere obsolete e verranno ricalcolate.',
		'JOB.CURRENT_STATUS': 'Stato attuale',
		'JOB.DELETE.QUESTION': 'Vuole davvero cancellare questo lavoro?',
		'JOB.DELETE.SUCCESS': 'Il lavoro sta per essere cancellato',
		'JOB.DETAILS': 'Dettagli sul lavoro',
		'JOB.DRIVER_IMPLEMENT': 'Eliminare o modificare il driver/implemento.',
		'JOB.EDIT': 'Modifica lavoro',
		'JOB.REGENERATE': 'Rigenerare il lavoro',
		'JOB.REGENERATE.DRIVER': 'Aggiornare i dati del driver',
		'JOB.REGENERATE.FIELDS': 'Aggiornare i dati del campo',
		'JOB.REGENERATE.IMPLEMENT': 'Aggiornare i dati di implementazione',
		'JOB.REGENERATE.INTRO': 'Se i dati di fatturazione delle macchine, degli attrezzi o dei conducenti sono cambiati, possono essere aggiornati.',
		'JOB.REGENERATE.LOCATIONS': 'Aggiornare i dati sulla posizione',
		'JOB.REGENERATE.MACHINE': 'Aggiornare i dati della macchina',
		'JOB.REGENERATE.QUESTION': 'Quali dati devono essere aggiornati?',
		'JOB.REGENERATE.SUCCESS': 'Giobbe sarà rigenerato',
		'JOB.SPLIT': 'Lavoro diviso',
		'JOB.SPLIT.ADD_SPLIT_TIME': 'Aggiungere il tempo intermedio',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO': 'Per impostazioni precise al secondo, il cursore dell\'ora può essere azionato anche con i pulsanti freccia.',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO2': 'Aggiungere il tempo (o i tempi) per suddividere il lavoro.',
		'JOB.SPLIT.NO_CHANGE': 'Nessun cambiamento di lavoro',
		'JOB.SPLIT.NO_SPLITS': 'Non sono stati selezionati orari per la suddivisione.',
		'JOB.UPDATE': 'Aggiornare i lavori',
		'JOB.WAITING_TIME_UNTIL_READY': 'A seconda dello stato attuale, potrebbero essere necessari alcuni minuti prima che il lavoro possa essere mostrato completamente.',
		'JOBS': 'Lavori',
		'JOBS.ALL': 'Tutti i lavori',
		'JOBS.ARCHIVE.PARTIAL': 'Alcuni lavori sono archiviati.',
		'JOBS.ARCHIVE.QUESTION': 'Si desidera davvero archiviare i lavori selezionati?',
		'JOBS.ARCHIVE.SUCCESS': 'I lavori saranno archiviati',
		'JOBS.CREATE_TASK': 'Creare un\'attività',
		'JOBS.DELETE.QUESTION': 'Si desidera davvero eliminare i lavori selezionati? Tutti i dati dei lavori verranno rimossi in modo irreversibile.',
		'JOBS.DELETE.SUCCESS': 'I lavori verranno cancellati',
		'JOBS.DELETED.FAILURE': 'Non è stato possibile eliminare alcuni lavori.',
		'JOBS.EDIT': 'Modifica lavori',
		'JOBS.EDIT.SUCCESS': 'I lavori saranno modificati',
		'JOBS.IN_TASK': 'Offerte di lavoro in mansioni',
		'JOBS.MERGE.SUCCESS': 'I lavori verranno accorpati',
		'JOBS.MERGING': 'Unire i lavori',
		'JOBS.NO': 'Nessun lavoro',
		'JOBS.NOT_SELECTED': 'Nessun lavoro selezionato',
		'JOBS.REGENERATE': 'Rigenerare posti di lavoro',
		'JOBS.REGENERATE.SUCCESS': 'I posti di lavoro saranno rigenerati',
		'JOBS.SELECTED': 'Lavori selezionati',
		'JOBS.TASK_CREATED': 'Attività creata con successo',
		'JOBS.UPDATE.SUCCESS': 'I lavori saranno aggiornati',
		'JOBS.WITHOUT_TASK': 'Lavori senza mansioni',
		'JOBS.WITH_TASK': 'Offerte di lavoro in attività',
		'KILOMETERS': 'Chilometri',
		'LANGUAGE': 'Lingua',
		'LANGUAGE.ADD': 'Aggiungi lingua',
		'LANGUAGE.CODE': 'Codice lingua',
		'LANGUAGE.DEFAULT': 'Lingua predefinita',
		'LASTNAME': 'Cognome',
		'LAST_ONLINE': 'Ultimo online',
		'LAST_UPDATED': 'Ultimo aggiornamento',
		'LATITUDE': 'Latitudine',
		'LOAD.MORE': 'Per saperne di più',
		'LOADS': 'Carichi',
		'LOCATION': 'Posizione',
		'LOCATION.ADD': 'Aggiungi posizione',
		'LOCATION.ADD.SUCCESS': 'Posizione aggiunta con successo',
		'LOCATION.DEACTIVATE.QUESTION': 'Volete davvero disattivare la posizione?',
		'LOCATION.DEACTIVATE.SUCCESS': 'Posizione disattivata con successo',
		'LOCATION.DELETE.QUESTION': 'Volete davvero eliminare la posizione?',
		'LOCATION.DELETE.SUCCESS': 'Posizione disattivata con successo',
		'LOCATION.DETAILS': 'Dettagli sulla posizione',
		'LOCATION.DRAW.START': 'Contrassegnate subito la posizione nella mappa!',
		'LOCATION.EDIT.SUCCESS': 'Posizione modificata con successo',
		'LOCATIONS': 'Luoghi',
		'LOCATIONS.ALL': 'Tutte le sedi',
		'LOCATIONS.DEACTIVATE.FAILURE': 'Non è stato possibile disattivare alcune postazioni.',
		'LOCATIONS.DEACTIVATE.QUESTION': 'Volete davvero disattivare le posizioni?',
		'LOCATIONS.DEACTIVATE.SUCCESS': 'Posizioni disattivate con successo',
		'LOCATIONS.DELETE.FAILURE': 'Non è stato possibile eliminare alcune posizioni.',
		'LOCATIONS.DELETE.QUESTION': 'Si desidera davvero eliminare le posizioni selezionate?',
		'LOCATIONS.DELETE.SUCCESS': 'Posizioni eliminate con successo',
		'LOCATIONS.NO': 'Nessuna posizione',
		'LOCATIONS.NOT_SELECTED': 'Nessuna località selezionata',
		'LOCATIONS.REACTIVATE.FAILURE': 'Alcune sedi non potevano essere riattivate.',
		'LOCATIONS.REACTIVATE.QUESTION': 'Si desidera davvero riattivare le posizioni selezionate?',
		'LOCATIONS.REACTIVATE.SUCCESS': 'Sedi riattivate con successo',
		'LOCATIONS.SELECTED': 'Luoghi selezionati',
		'LOG': 'Registro dei messaggi',
		'LOGIN': 'Accedi',
		'LOGIN.NOT_UNLOCKED_YET': 'Non è ancora stato sbloccato?',
		'LOGIN.NO_ACCOUNT_YET': 'Non avete ancora un account?',
		'LOGIN.PASSWORD_FORGOTTEN': 'Password dimenticata?',
		'LOGIN.REGISTER': 'Registro',
		'LOGIN.REMEMBER_PASSWORD': 'Ricorda la password',
		'LOGIN.UNLOCK': 'Sbloccare',
		'LOG_OUT': 'Disconnettersi',
		'LONGITUDE': 'Longitudine',
		'LOST_PASSWORD.CHANGE_PASSWORD': 'Modifica della password',
		'LOST_PASSWORD.ENTER_ACTIVATION': 'Inserire il codice di attivazione ricevuto via e-mail.',
		'LOST_PASSWORD.ENTER_EMAIL_HERE': 'Inserire l\'e-mail qui.',
		'LOST_PASSWORD.ENTER_VALID_EMAIL': 'Inserire un indirizzo e-mail valido.',
		'MAC': ' MAC ',
		'MACHINE': 'Macchina',
		'MACHINE.ADD': 'Aggiungi macchina',
		'MACHINE.ADD.SUCCESS': 'Macchina aggiunta con successo',
		'MACHINE.DELETE.QUESTION': 'Volete davvero eliminare la macchina?',
		'MACHINE.DELETE.SUCCESS': 'Macchina cancellata con successo ',
		'MACHINE.DETAILS': 'Dettagli macchina',
		'MACHINE.EDIT': 'Modifica macchina',
		'MACHINE.EDIT.SUCCESS': 'Macchina montata con successo',
		'MACHINE.INTERVAL.ADD': 'Aggiungi intervallo macchina',
		'MACHINE.LIVE_STATUS': 'Stato di funzionamento della macchina',
		'MACHINE.NO': 'Nessuna macchina',
		'MACHINE.RELOAD_POSITIONS': 'Ricaricare le posizioni della macchina',
		'MACHINE.STATUS': 'Stato della macchina',
		'MACHINES': 'Macchine',
		'MACHINES.ALL': 'Tutte le macchine',
		'MACHINES.DEACTIVATE.FAILURE': 'Alcune macchine non potevano essere disattivate.',
		'MACHINES.DEACTIVATE.QUESTION': 'Si desidera davvero disattivare le macchine selezionate?',
		'MACHINES.DEACTIVATE.SUCCESS': 'Macchine disattivate con successo',
		'MACHINES.DELETE.FAILURE': 'Non è stato possibile eliminare alcune macchine.',
		'MACHINES.DELETE.QUESTION': 'Si desidera davvero eliminare le macchine selezionate?',
		'MACHINES.DELETE.SUCCESS': 'Macchine eliminate con successo',
		'MACHINES.MANAGEMENT': 'Gestione delle macchine',
		'MACHINES.NO': 'Nessuna macchina',
		'MACHINES.NOT_SELECTED': 'Nessuna macchina selezionata',
		'MACHINES.NO_LICENSE.WARNING': 'La macchina non ha una licenza allegata. Senza licenza non vengono registrati dati.',
		'MACHINES.REACTIVATE.FAILURE': 'Alcune macchine non potevano essere riattivate.',
		'MACHINES.REACTIVATE.QUESTION': 'Si desidera davvero riattivare le macchine selezionate?',
		'MACHINES.REACTIVATE.SUCCESS': 'Macchine riattivate con successo',
		'MACHINES.SELECTED': 'Macchine selezionate',
		'MACHINE_COMBINATION': 'Machine combination',
		'MACHINE_IMPLEMENT': 'Macchina/implementazione',
		'MAC_DEVICES': 'Dispositivi collegati a una macchina',
		'MAINTENANCE': 'Manutenzione',
		'MAINTENANCE.AMOUNT': 'Importo di manutenzione',
		'MAINTENANCE.PERIOD': 'Periodo di manutenzione',
		'MAKE': 'Produttore',
		'MANURE': 'Letame',
		'MANURE.TYPE': 'Tipo di concime',
		'MAP': 'Mappa',
		'MAP.SECTION': 'Sezione mappa',
		'MAP.SECTION.CHANGE': 'Modifica della sezione della mappa',
		'MARKER.ADD': 'Aggiungere un nuovo marcatore',
		'MARKER.EDIT.BORDERS': 'Modifica dei confini',
		'MARKER.ENTRANCE': 'Ingresso',
		'MARKER.EXIT': 'Uscita',
		'MARKER.INFO': 'Info',
		'MARKER.WARN': 'Avvertire',
		'MAX': 'Massimo',
		'MAX_VALUE': 'Valore massimo',
		'MERGE': 'Unire',
		'MESSAGES.NO': 'Nessun messaggio',
		'MILEAGE': 'Chilometraggio',
		'MILEAGE.INVALID': 'Chilometraggio non valido',
		'MIN': 'Minimo',
		'MIN_VALUE': 'Valore minimo',
		'MOBILE': 'Mobile',
		'MODE.SWITCH': 'Modalità di commutazione',
		'MODEL': 'Modello',
		'MYPROFILE': 'Il mio profilo',
		'MYPROFILE.BASIC_DATA': 'Dati di base',
		'MYPROFILE.BASIC_DATA.EDIT.SUCCESS': 'I vostri dati di base sono stati modificati',
		'NAME': 'Nome',
		'NAV.ACTIVITIES': 'Attività',
		'NAV.ADMIN': 'Amministratore',
		'NAV.ADMIN.DASHBOARD': 'Cruscotto',
		'NAV.ADMIN.INFO_VIEW': 'Admin Info',
		'NAV.ADMIN.JOB_IMPORT_VIEW': 'Job import',
		'NAV.ADMIN.JOB_VIEW': 'Vista sul lavoro',
		'NAV.ADMIN.USERS': 'Gestione degli utenti',
		'NAV.CUSTOMERS': 'I clienti',
		'NAV.DASHBOARD': 'Cruscotto',
		'NAV.DATA_PREPARATION': 'Preparazione dei dati',
		'NAV.EMPLOYEES': 'I dipendenti',
		'NAV.ENTERPRISE': 'Impresa',
		'NAV.FIELDS': 'Campi',
		'NAV.FILE_TRANSFER': 'ISO Taskdata ',
		'NAV.HARDWARE': 'Hardware',
		'NAV.HARDWARE_SETUP': 'Configurazione dell\'hardware',
		'NAV.IMPLEMENTS': 'Attrezzi',
		'NAV.LOCATIONS': 'Luoghi',
		'NAV.MACHINES': 'Macchine',
		'NAV.MY_SECTION': 'La mia sezione',
		'NAV.PATH_PLANNINGS': 'Path planning',
		'NAV.RETAILER': 'Rivenditore',
		'NAV.SETTINGS': 'Impostazioni',
		'NAV.SETTINGS.ADAPTER': 'Adattatore',
		'NAV.SETTINGS.GENERAL': 'Impresa',
		'NAV.SETTINGS.PARTNER': 'Partner',
		'NAV.STATISTIC': 'Statistiche',
		'NAV.TECH': ' TECH ',
		'NAV.TRANSLATION.EDIT': 'Modifica della traduzione',
		'NAV.TRANSLATION_MANAGEMENT': 'Gestione delle traduzioni',
		'NETWORK.ACCESS_TECHNOLOGY': 'Tecnologia di accesso',
		'NETWORK.OPERATOR': 'Operatore',
		'NEXT': 'Avanti',
		'NO': 'No',
		'NONE': 'Nessuno',
		'NOTICE': 'Avviso',
		'NON_PRODUCTIVE_TIME': 'Tempo non produttivo',
		'NON_PRODUCTIVE_TIMES': 'Tempi non produttivi',
		'NON_PRODUCTIVE_TIMES.SEPARATOR': 'Separator for non productive time computation',
		'NOT_READ': 'Non è stato possibile leggerlo.',
		'NO_DATA': 'Nessun dato',
		'ONLY_ON': 'Solo su',
		'OPACITY': 'Opacità',
		'OPERATING_HOURS': 'Orario di funzionamento',
		'OPERATING_HOURS.INVALID': 'Orario di funzionamento non valido',
		'OPERATION': 'Operazione',
		'OPERATION.NOT_SELECTED': 'Nessuna operazione sul campo selezionato.',
		'OPERATION.SELECT': 'Selezionare l\'operazione',
		'OPERATIONS': 'Operazioni',
		'OPERATIONS.ARRIVAL': 'Arrivo',
		'OPERATIONS.CUSTOMER': 'Operazioni per il cliente',
		'OPERATIONS.FIELD': 'Operazioni sul campo',
		'OPERATIONS.FIELDS': 'Operazioni sui campi',
		'OPERATIONS.FIELD_TIME': 'Tempo in campo',
		'OPERATIONS.GEOMETRY': 'Geometria',
		'OPERATIONS.LOCATION': 'Operazioni in loco',
		'OPERATIONS.LOCATIONS': 'Operazioni sulle sedi',
		'OPERATIONS.NO': 'Nessuna operazione',
		'OPERATIONS.PREPARATION': 'Preparazione',
		'OVERRIDE.NO': 'Nessun annullamento',
		'PAGE': 'Page',
		'PAGE.OF': 'of',
		'PAGINATION.PER_PAGE': 'Per pagina',
		'PAGINATION.TOTAL': 'totale',
		'PAGINATOR.FIRST_PAGE': 'Prima pagina',
		'PAGINATOR.ITEMS_PER_PAGE': 'Articoli per pagina',
		'PAGINATOR.LAST_PAGE': 'Ultima pagina',
		'PAGINATOR.NEXT_PAGE': 'Pagina seguente',
		'PAGINATOR.OF': 'di',
		'PAGINATOR.PREVIOUS_PAGE': 'Pagina precedente',
		'PARTNER_CONNECTION': 'Collegamento con il partner',
		'PARTNER_CONNECTION.DOES_NOT_EXPIRE': 'Non ha scadenza',
		'PARTNER_CONNECTION.EXPIRES_ON': 'Scade il',
		'PASSWORD': ' Password ',
		'PASSWORD.CHANGE': 'Modifica della password',
		'PASSWORD.CHANGE.ACTIVATE': 'Password attuale',
		'PASSWORD.CHANGE.SUCCESS': 'Password modificata con successo',
		'PASSWORD.CONFIRM': 'Confermare la nuova password',
		'PASSWORD.LENGTH.REQUIRED': 'La password deve essere lunga almeno 6 caratteri',
		'PASSWORD.NEW_PASSWORD': 'Nuova password',
		'PASSWORD.NO_MATCH': 'Errore nella conferma della password!',
		'PATH_PLANNING.ADD': 'Plan path',
		'PATH_PLANNING.ADD.SUCCESS': 'Planned path successfully added',
		'PATH_PLANNING.ANGLE': 'Angle',
		'PATH_PLANNING.ANGLE.LONGEST_SIDE': 'Longest side',
		'PATH_PLANNING.ANGLE.OPTIMAL': 'Optimal',
		'PATH_PLANNING.ANGLE.WORKING': 'Working angle',
		'PATH_PLANNING.AREA.COVERED': 'Covered area',
		'PATH_PLANNING.AREA.OVERLAP': 'Overlapped area',
		'PATH_PLANNING.AREA.UNCOVERED': 'Uncovered area',
		'PATH_PLANNING.DETAILS': 'Planned path',
		'PATH_PLANNING.GENERATE_PATH': 'Generate path',
		'PATH_PLANNING.GEOMETRY.CHANGED.QUESTION': 'The field boundary has been changed. Do you want to store the boundary as the current boundary of the field?',
		'PATH_PLANNING.NAME': 'Path planning name',
		'PATH_PLANNING.NAME.EXPLANATION': 'Give the path planning a name',
		'PATH_PLANNING.NOT_ENOUGH_DATA_EXPECTATION': 'Currently there is not enough data to compute the expected fuel consumption, CO2 consumption and cost',
		'PATH_PLANNING.SELECT.FIELD': 'Select the field you want the path to be planned for',
		'PATH_PLANNING.SEND_TO_MACHINE': 'Send to machine',
		'PATH_PLANNING.SETTINGS.CHANGED.QUESTION': 'The settings have been changed after generating the currently shown planned path and will not be reflected when saved. Do you want to continue?',
		'PATH_PLANNING.SUBDIVIDE': 'Subdivide field',
		'PATH_PLANNINGS.DEACTIVATE.FAILURE': 'Some of the planned paths could not be deactivated',
		'PATH_PLANNINGS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the planned path?',
		'PATH_PLANNINGS.DEACTIVATE.SUCCESS': 'Planned paths have been deactivated',
		'PATH_PLANNINGS.DELETE.FAILURE': 'Some of the planned paths could not be deleted',
		'PATH_PLANNINGS.DELETE.QUESTION': 'Do you really want to delete the planned path?',
		'PATH_PLANNINGS.DELETE.SUCCESS': 'Planned paths deleted successfully',
		'PATH_PLANNINGS.MANAGEMENT': 'Planned paths management',
		'PATH_PLANNINGS.NOT_SELECTED': 'No planned path selected',
		'PATH_PLANNINGS.REACTIVATE.FAILURE': 'Some of the planned paths could not be reactivated',
		'PATH_PLANNINGS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected planned paths?',
		'PATH_PLANNINGS.REACTIVATE.SUCCESS': 'Planned paths reactivated successfully',
		'PATTERN': 'Pattern',
		'PATTERN.END_AT_ENTRANCE': 'End at entrance',
		'PATTERN.START': 'Pattern start/end',
		'PATTERN.START_AT_ENTRANCE': 'Start at entrance',
		'PAUSE': 'Pause',
		'PERFORMANCE.AVERAGE': 'Prestazioni medie',
		'PERFORMANCE.AVERAGE.EXPLAINATION': 'Questo valore tiene conto anche di tutti gli stati di lavoro, compresi i tempi di preparazione e di circolazione.',
		'PERFORMANCE.AVERAGE.FIELD': 'Prestazioni medie (campo)',
		'PERFORMANCE.AVERAGE.FIELD.EXPLAINATION': 'Questo valore tiene conto solo del lavoro su un campo, dell\'attesa su un campo e dell\'attivazione di un campo.',
		'PERFORMANCE.TOTAL': 'Prestazioni totali',
		'PHONE': 'Telefono di contatto',
		'PHONE.INVALID': 'Telefono non valido',
		'PHONE_MOBILE': 'Telefono (mobile)',
		'PH_VALUE': 'Valore PH',
		'PLAY': 'Play',
		"POI": "Point of interest",
		"POI.ADD": "Add point of interest",
		'POSTCODE': 'Codice postale',
		'PREVIOUS': 'Precedente',
		'PROCESS': 'Processo',
		'PROCESSED': 'Elaborato',
		'PROCESSED.FAILURE': 'Errore durante l\'elaborazione',
		'PROCESSED.SUCCESSFULL': 'Elaborato con successo',
		'PRODUCT': 'Prodotto',
		'PROGRESS': 'Progressi',
		'PROJECTION': 'Proiezione',
		'RAW_DATA': 'Dati grezzi',
		'RECEIVED.AT': 'Ricevuto a',
		'REGENERATE': 'Rigenerare',
		'REGENERATE.SELECTED': 'Rigenerare selezionato',
		'REGISTER': 'Registro',
		'REGISTER.ALREADY_REGISTERED?': 'Siete già registrati?',
		'REGISTER.I_ACCEPT_THE': 'Accetto il',
		'RELOAD': 'Ricarica',
		'REMOVE': 'Rimuovere',
		'RENEW': 'Rinnovare',
		'REOCURRING': 'Ricorrente',
		'REPORT': 'Rapporto',
		'RESET': 'Reset',
		'RESOLUTION': 'Risoluzione',
		'RESTORE.DRIVER': 'Ripristino del condutore',
		'RESTORE.IMPLEMENT': 'Ripristino dell\'implementi',
		'ROAD': 'Strada',
		'ROLE': 'Ruolo',
		'RUNTIME_H': 'Tempo di esecuzione in h',
		'SAFETY_CHECK': 'Controllo di sicurezza',
		'SATELITE': 'Satellite',
		'SAVE': 'Risparmiare',
		'SCALE.TYPE': 'Tipo di scala',
		'SEARCH': 'Ricerca',
		'SEASON_YEAR': 'Stagione',
		'SEASON_YEAR.START': 'Inizio della stagione',
		'SELECT.ALL': 'Seleziona tutti',
		'SELECT.CLEAR': 'Rimuovere la selezione',
		'SELECT.FIELD': 'Select field',
		'SENSORDATA': 'Dati del sensore',
		'SENSORDATA.DESCRIPTION': 'Visualizzazione dei dati sensibili',
		'SENSORDATA.SELECT_SENSOR': 'Selezionare il sensore',
		'SENSORDATA.SHOW_WORKSTATE_COLORS': 'Mostra i colori dello stato di lavoro',
		'SENSOR_PARAMETER': 'Parametro del sensore',
		'SENSOR_PARAMETER.ADD': 'Aggiungere il parametro del sensore',
		'SENSOR_PARAMETER.DEFINE_FOR_IMPLEMENT': 'Definire i parametri dei singoli sensori per l\'attrezzo selezionato.',
		'SENSOR_PARAMETER.DEFINE_INDIVIDUAL_PARAM': 'Definire il parametro individuale del sensore.',
		'SENSOR_PARAMETER.INDIVIDUAL_SENSOR_PARAM': 'Parametro individuale del sensore',
		'SENSOR_PARAMETER.NOT_REMOVABLE_USED_IN_OTHER_PARAMETER': 'Il parametro del sensore è utilizzato in un\'altra configurazione di parametri',
		'SENSOR_PARAMETERS': 'Parametri del sensore',
		'SENSOR_PARAMETERS.NO': 'Nessun parametro del sensore',
		'SERIAL': 'Numero di serie',
		'SETTINGS': 'Impostazioni',
		'SETTINGS.ADDITIONAL': 'Additional settings',
		'SETTINGS.ADVANCED': 'Advanced settings',
		'SETTINGS.AGRIROUTER_CAN_BE_CONNECTED': 'Il vostro account Agrirouter può essere collegato a exatrek per condividere i dati.',
		'SETTINGS.AGRIROUTER_CONNECTED_AND_READY': 'Agrirouter è collegato e pronto all\'uso. La connessione è valida fino a quando',
		'SETTINGS.CONNECTION_TO_PARTNERS': 'Collegamento con i partner exatrek',
		'SETTINGS.FARMNET_FIELD_SYNC': 'Sincronizzare i campi da 365Farmnet a exatrek',
		'SETTINGS.FARMNET_IMPLEMENT_SYNC': 'Sincronizzare le implementazioni da 365Farmnet a exatrek',
		'SETTINGS.FARMNET_MACHINE_SYNC': 'Sincronizzazione delle macchine da 365Farmnet a exatrek',
		'SETTINGS.GO_TO_FARMNET': 'Vai a 365Farmnet',
		'SETTINGS.ONLY_FARMNET_WEBAPP': 'La sincronizzazione da e verso 365farmnet può essere utilizzata solo dalla webapp 365farmnet.',
		'SHOW': 'Mostra',
		'SHOW_DIRECTION': 'Mostra indicazioni',
		'SHOW_EVENTS': 'Mostra eventi',
		'SHOW_FIELDS': 'Mostra i campi',
		'SHOW_LOCATIONS': 'Mostra le località',
		'SHOW_OFFLINE_MACHINES': 'Mostra macchine offline',
		'SHOW_TRACKS': 'Mostra i brani',
		'SHOW_TRACKS_': 'Mostra i brani',
		'SNACKBAR.DAYS': 'giorni',
		'SNACKBAR.LICENSE_EXPIRATION_WARNING': 'La licenza scade tra',
		'SNACKBAR.MACHINE_ONLINE_WARNING': 'Almeno una macchina non è online da tempo!',
		'SORT_BY': 'Ordina per',
		'SPEED': 'Velocità',
		'SPEED.AVERAGE': 'Velocità media',
		'SPEED.FASTER': 'Faster',
		'SPEED.RESET': 'Reset speed',
		'SPEED.SIGNAL.OVERRIDE': 'Esclusione del segnale di velocità',
		'SPEED.SLOWER': 'Slower',
		'SPEED.WORKING': 'Working speed',
		'SPLIT': 'Dividere',
		'START': 'Inizio',
		'STATISTICS': 'Statistics',
		'STATUS': 'Stato',
		'STOP': 'Stop',
		'STORAGE': 'Immagazzinamento',
		'STORAGE.USB': 'Memoria USB',
		'STORAGE.USB.USED': 'Memoria USB utilizzata',
		'STORAGE.USED': 'Stoccaggio utilizzato',
		'SYMBOLIZATION': 'Simbolizzazione',
		'TASK': 'Attività',
		'TASK.ADDABLE_JOBS': 'Lavori aggiungibili',
		'TASK.ADD_JOBS': 'Aggiungere lavori all\'attività',
		'TASK.ARCHIVED_JOB_WARNING': 'Questo task contiene lavori archiviati e non verrà mostrato per intero!',
		'TASK.DELETE.JOB.FAILURE': 'Un\'attività deve contenere almeno un lavoro!',
		'TASK.DELETE.JOB.QUESTION': 'Si vuole davvero eliminare il lavoro dell\'attività?',
		'TASK.DELETE.JOB.SUCCESS': 'Lavoro cancellato con successo dall\'attività',
		'TASK.DELETE.QUESTION': 'Volete davvero eliminare l\'attività?',
		'TASK.DELETE.SUCCESS': 'Attività eliminata con successo',
		'TASK.EDIT': 'Modifica attività',
		'TASK.EDIT.SUCCESS': 'Attività modificata con successo',
		'TASK.EXPORT_DETAILS': 'Esportazione dell\'attività selezionata',
		'TASK.JOBS_TO_ADD': 'Lavori da aggiungere',
		'TASK.NEW': 'Nuova attività',
		'TASKS': 'Compiti',
		'TASKS.NO': 'Nessuna attività',
		'TASK_CONTROLLER.ACTIVE': 'Task Controller (DataLog) attivo',
		'TASK_CONTROLLER.COMPAT_ACTIVE': 'Modalità di compatibilità del task controller attiva',
		'TAX_ID': 'Codice fiscale',
		'TC': 'Task Controller ',
		'TC.ACTIVE': 'Task Controller attivo',
		'TC.TC_COMP': 'Task Controller comp.',
		'TERMINAL.NO': 'Nessun terminale',
		'TERMINAL.TYPE': 'Tipo di terminale',
		'TEST.SUCCESS': 'La richiesta è andata a buon fine. Riceverete presto un\'e-mail.',
		'TIME': 'Tempo',
		'TIME.REMAINING': 'Tempo rimanente',
		'TIMEZONE': 'Fuso orario',
		'TITLE': 'Richiesta di un account di prova',
		'TOKEN': 'Codice di accesso',
		'TOTAL': 'Totale',
		'TRACKS.LOADING': 'Caricamento dei brani...',
		'TRACK.WIDTH': 'Larghezza della carreggiata',
		'TRACK.WIDTH.NARROW': 'Stretto',
		'TRACK.WIDTH.NORMAL': 'Normale',
		'TRACK.WIDTH.WIDE': 'Ampio',
		'TRACK_LENGTH': 'Lunghezza del tracciato',
		'TRACK_REPLAY': 'Track replay',
		'TRANSLATABLE': 'Traducibile',
		'TRANSLATABLE.ADD': 'Aggiungi traducibile',
		'TRANSLATION': 'Traduzione',
		'TRANSPORT': 'Trasporto',
		'TRANSPORT/AXLES': 'Trasporto/Assi',
		'TRANSPORTAMOUNT_AXLES': 'Importo del trasporto/Assi',
		'TURNINGS': 'Turnings',
		'TURNING_OFFSET': 'Turning offset',
		'TURNING_RADIUS': 'Turning radius',
		'TYPE': 'Tipo',
		'UNDO': 'Annullamento',
		'UNIT': 'Unità',
		'UNKNOWN': 'Sconosciuto',
		'UNTIL': 'fino a quando',
		'UPLOAD': 'Caricare',
		'UPLOAD.FINISHED': 'Caricamento finito',
		'UPLOADING': 'Caricamento',
		'USER.EDIT.SUCCESS': 'Utente modificato con successo',
		'USERNAME': 'Nome utente',
		'USERNAME.LENGTH.REQUIRED': 'Il nome utente deve essere lungo almeno 6 caratteri.',
		'USERNAME.TAKEN': 'Questo nome è già stato preso.',
		'USERNAME.VALID.CHARS': 'Il nome utente può contenere solo lettere, numeri, \"-\" e \"_\".',
		'USERROLE': 'Ruolo dell\'utente',
		'USERSTATUS': 'Stato dell\'utente',
		'USER_CREATED': 'Utente creato',
		'WAITING': 'Attesa',
		'WARNING': 'Avvertenze',
		'WEEK.CURRENT': 'Settimana corrente',
		'WEEK.NEXT': 'La prossima settimana',
		'WEEK.PREVIOUS': 'Settimana precedente',
		'WEEK.SELECTED': 'Settimana selezionata',
		'WEIGHING': 'Pesatura',
		'WIDTH.INVALID': 'Larghezza non valida',
		'WORKING_HOURS': 'Orario di lavoro',
		'WORKING_TIME': 'Tempo di lavoro',
		'WORKING_WIDTH': 'Larghezza di lavoro',
		'WORKSTATE': 'Stato di lavoro',
		'WORKSTATES': 'Stati di lavoro',
		'YES': 'Sì',
    'NO_POSITION_MACHINE_FOUND': 'Nessuna macchina di posizione trovata',
	}
};
